// Official subclass labels are kept in their source language.
// WZ 2025, updated 2026-10-04: Statistische Ämter des Bundes und der Länder.
// https://www.klassifikationsserver.de/klassService/thyme/variant/wz2025
// NAF rév. 2 (valid through 2026): Insee, https://www.insee.fr/fr/information/2120875
export const WZ_2025_SUBCLASSES = [
    ['01.11.0', 'Anbau von anderem Getreide als Reis sowie von Hülsenfrüchten und Ölsaaten'],
    ['01.12.0', 'Anbau von Reis'],
    ['01.13.1', 'Anbau von Gemüse und Melonen'],
    ['01.13.2', 'Anbau von Kartoffeln sowie sonstigen Wurzeln und Knollen'],
    ['01.14.0', 'Anbau von Zuckerrohr'],
    ['01.15.0', 'Anbau von Tabak'],
    ['01.16.0', 'Anbau von Faserpflanzen'],
    ['01.19.1', 'Anbau von Zierpflanzen zum Schnitt'],
    ['01.19.2', 'Erzeugung von Blumensamen'],
    ['01.19.9', 'Anbau von sonstigen ein- und zweijährigen Pflanzen a. n. g.'],
    ['01.21.0', 'Anbau von Wein- und Tafeltrauben'],
    ['01.22.0', 'Anbau von tropischen und subtropischen Früchten'],
    ['01.23.0', 'Anbau von Zitrusfrüchten'],
    ['01.24.0', 'Anbau von Kern- und Steinobst'],
    ['01.25.1', 'Anbau von Erdbeeren'],
    ['01.25.9', 'Anbau von sonstigem Obst und Nüssen a. n. g.'],
    ['01.26.0', 'Anbau von ölhaltigen Früchten'],
    ['01.27.0', 'Anbau von Pflanzen zur Herstellung von Getränken'],
    [
        '01.28.0',
        'Anbau von Gewürzpflanzen, Pflanzen für aromatische, narkotische und pharmazeutische Zwecke',
    ],
    ['01.29.0', 'Anbau sonstiger mehrjähriger Pflanzen'],
    ['01.30.1', 'Anbau von Zimmerpflanzen, Beet- und Balkonpflanzen'],
    ['01.30.2', 'Betrieb von Baumschulen'],
    ['01.41.0', 'Haltung von Milchkühen'],
    ['01.42.0', 'Haltung von sonstigen Rindern'],
    ['01.43.0', 'Haltung von Pferden und Eseln'],
    ['01.44.0', 'Haltung von Kamelen'],
    ['01.45.0', 'Haltung von Schafen und Ziegen'],
    ['01.46.0', 'Haltung von Schweinen'],
    ['01.47.1', 'Haltung von Legehennen zur Konsumeiererzeugung'],
    ['01.47.2', 'Betrieb von Brütereien'],
    ['01.47.9', 'Haltung von Geflügel a. n. g.'],
    ['01.48.1', 'Haltung von Insekten'],
    ['01.48.9', 'Sonstige Tierhaltung a. n. g.'],
    ['01.50.0', 'Gemischte Landwirtschaft'],
    ['01.61.0', 'Erbringung von landwirtschaftlichen Dienstleistungen für den Pflanzenbau'],
    ['01.62.0', 'Erbringung von landwirtschaftlichen Dienstleistungen für die Tierhaltung'],
    ['01.63.1', 'Nach der Ernte anfallende Tätigkeiten in der pflanzlichen Erzeugung'],
    ['01.63.2', 'Saatgutaufbereitung'],
    ['01.70.0', 'Jagd, Fallenstellerei und damit verbundene Tätigkeiten'],
    ['02.10.0', 'Forstwirtschaft'],
    ['02.20.0', 'Holzeinschlag'],
    ['02.30.0', 'Sammeln von wildwachsenden Produkten, ohne Holz'],
    ['02.40.0', 'Erbringung von Dienstleistungen für Forstwirtschaft und Holzeinschlag'],
    ['03.11.0', 'Meeresfischerei'],
    ['03.12.0', 'Süßwasserfischerei'],
    ['03.21.0', 'Meeresaquakultur'],
    ['03.22.0', 'Süßwasseraquakultur'],
    ['03.30.0', 'Erbringung von Dienstleistungen für Fischerei und Aquakultur'],
    ['05.10.0', 'Steinkohlenbergbau'],
    ['05.20.0', 'Braunkohlenbergbau'],
    ['06.10.0', 'Gewinnung von Erdöl'],
    ['06.20.0', 'Gewinnung von Erdgas'],
    ['07.10.0', 'Eisenerzbergbau'],
    ['07.21.0', 'Bergbau auf Uran- und Thoriumerze'],
    ['07.29.0', 'Sonstiger NE-Metallerzbergbau'],
    [
        '08.11.0',
        'Gewinnung von Naturwerksteinen, Kalk- und Gipsstein, Schiefer und sonstigem Gestein',
    ],
    ['08.12.1', 'Gewinnung von Quarzsanden und kieselsauren Sanden'],
    ['08.12.2', 'Gewinnung von anderen Natursanden und Kies'],
    ['08.12.3', 'Gewinnung von Kaolin und anderem kaolinhaltigen Ton und Lehm'],
    ['08.91.0', 'Bergbau auf chemische und Düngemittelminerale'],
    ['08.92.0', 'Torfgewinnung'],
    ['08.93.0', 'Gewinnung von Salz'],
    ['08.99.0', 'Gewinnung von Steinen und Erden a. n. g.'],
    ['09.10.0', 'Erbringung von Dienstleistungen für die Gewinnung von Erdöl und Erdgas'],
    [
        '09.90.0',
        'Erbringung von Dienstleistungen für den sonstigen Bergbau und die Gewinnung von Steinen und Erden',
    ],
    ['10.11.1', 'Schlachten von Schweinen'],
    ['10.11.2', 'Schlachten von Rindern'],
    ['10.11.9', 'Schlachten von Tieren a. n. g.'],
    ['10.12.0', 'Schlachten von Geflügel'],
    ['10.13.1', 'Verarbeitung von Schweinefleisch'],
    ['10.13.2', 'Verarbeitung von Rindfleisch'],
    ['10.13.9', 'Fleischverarbeitung a. n. g.'],
    ['10.20.0', 'Fischverarbeitung'],
    ['10.31.0', 'Kartoffelverarbeitung'],
    ['10.32.0', 'Herstellung von Frucht- und Gemüsesäften'],
    ['10.39.0', 'Sonstige Verarbeitung von Obst und Gemüse'],
    ['10.41.0', 'Herstellung von Ölen und Fetten, ohne Margarine u. ä. Nahrungsfette'],
    ['10.42.0', 'Herstellung von Margarine u. ä. Nahrungsfetten'],
    ['10.51.0', 'Herstellung von Milcherzeugnissen'],
    ['10.52.0', 'Herstellung von Speiseeis'],
    ['10.61.0', 'Mahl- und Schälmühlen'],
    ['10.62.0', 'Herstellung von Stärke und Stärkeerzeugnissen'],
    ['10.71.0', 'Herstellung von Backwaren, ohne Dauerbackwaren'],
    ['10.72.0', 'Herstellung von Dauerbackwaren'],
    ['10.73.0', 'Herstellung von Teigwaren'],
    ['10.81.0', 'Herstellung von Zucker'],
    ['10.82.0', 'Herstellung von Süßwaren, ohne Dauerbackwaren'],
    ['10.83.0', 'Verarbeitung von Kaffee und Tee, Herstellung von Kaffee-Ersatz'],
    ['10.84.0', 'Herstellung von Würzmitteln und Soßen'],
    ['10.85.0', 'Herstellung von Fertiggerichten'],
    ['10.86.0', 'Herstellung von homogenisierten und diätetischen Nahrungsmitteln'],
    ['10.89.0', 'Herstellung von sonstigen Nahrungsmitteln a. n. g.'],
    ['10.91.0', 'Herstellung von Futtermitteln für Nutztiere'],
    ['10.92.0', 'Herstellung von Futtermitteln für sonstige Tiere'],
    ['11.01.0', 'Herstellung von Spirituosen'],
    ['11.02.0', 'Herstellung von Traubenwein'],
    ['11.03.0', 'Herstellung von Apfelwein und sonstigen gegorenen Getränken aus Obst'],
    ['11.04.0', 'Herstellung von Wermutwein und sonstigen aromatisierten Weinen'],
    ['11.05.0', 'Herstellung von Bier'],
    ['11.06.0', 'Herstellung von Malz'],
    ['11.07.0', 'Herstellung von Erfrischungsgetränken und Mineralwässern'],
    ['12.00.0', 'Tabakverarbeitung'],
    ['13.10.0', 'Spinnstoffaufbereitung und Spinnerei'],
    ['13.20.0', 'Weberei'],
    ['13.30.0', 'Veredlung von Textilien und Bekleidung'],
    ['13.91.0', 'Herstellung von gewirktem und gestricktem Stoff'],
    [
        '13.92.0',
        'Herstellung von Heimtextilien und konfektionierten Textilwaren für die Innenausstattung',
    ],
    ['13.93.0', 'Herstellung von Teppichen'],
    ['13.94.0', 'Herstellung von Seilerwaren'],
    ['13.95.0', 'Herstellung von Vliesstoff und nicht-konfektionierten Erzeugnissen daraus'],
    ['13.96.0', 'Herstellung von technischen Textilien'],
    ['13.99.0', 'Herstellung von sonstigen Textilwaren a. n. g.'],
    [
        '14.10.1',
        'Herstellung von Oberbekleidung für Herren und Knaben aus gewirktem und gestricktem Stoff',
    ],
    [
        '14.10.2',
        'Herstellung von Oberbekleidung für Damen und Mädchen aus gewirktem und gestricktem Stoff',
    ],
    ['14.10.3', 'Herstellung von gewirkter und gestrickter Wäsche (ohne Miederwaren)'],
    ['14.10.4', 'Herstellung von Strumpfwaren'],
    ['14.10.5', 'Herstellung von sonstiger Bekleidung aus gewirktem und gestricktem Stoff'],
    ['14.21.1', 'Herstellung von Oberbekleidung für Herren und Knaben'],
    ['14.21.2', 'Herstellung von Oberbekleidung für Damen und Mädchen'],
    ['14.21.9', 'Herstellung von sonstiger Oberbekleidung'],
    ['14.22.0', 'Herstellung von Wäsche'],
    ['14.23.0', 'Herstellung von Arbeits- und Berufsbekleidung'],
    ['14.24.0', 'Herstellung von Lederbekleidung und Pelzwaren'],
    ['14.29.0', 'Herstellung von sonstiger Bekleidung und Bekleidungszubehör a. n. g.'],
    ['15.11.0', 'Gerben, Färben, Zurichten von Leder und Fellen'],
    [
        '15.12.0',
        'Herstellung von Reisegepäck, Handtaschen, Sattlerwaren und Geschirren aus Stoffen aller Art',
    ],
    ['15.20.0', 'Herstellung von Schuhen'],
    ['16.11.0', 'Säge- und Hobelwerke'],
    ['16.12.0', 'Bearbeitung und Veredlung von Holz'],
    ['16.21.0', 'Herstellung von Furnier-, Sperrholz-, Holzfaser- und Holzspanplatten'],
    ['16.22.0', 'Herstellung von Parketttafeln'],
    [
        '16.23.0',
        'Herstellung von sonstigen Konstruktionsteilen, Fertigbauteilen, Ausbauelementen und Fertigteilbauten aus Holz',
    ],
    ['16.24.1', 'Herstellung von Paletten und anderen Ladungsträgern aus Holz'],
    ['16.24.2', 'Herstellung von Verpackungsmitteln aus Holz und von Böttcherwaren'],
    ['16.25.0', 'Herstellung von Türen und Fenstern aus Holz'],
    ['16.26.0', 'Herstellung von festen Brennstoffen aus pflanzlicher Biomasse'],
    ['16.27.0', 'Veredlung von Holzwaren'],
    ['16.28.0', 'Herstellung von sonstigen Holzwaren sowie Kork-, Flecht- und Korbwaren'],
    ['17.11.0', 'Herstellung von Holz- und Zellstoff'],
    ['17.12.0', 'Herstellung von Papier, Karton und Pappe'],
    [
        '17.21.0',
        'Herstellung von Wellpapier und -pappe sowie von Verpackungsmitteln aus Papier, Karton und Pappe',
    ],
    [
        '17.22.0',
        'Herstellung von Haushalts-, Hygiene- und Toilettenartikeln aus Zellstoff, Papier und Pappe',
    ],
    ['17.23.0', 'Herstellung von Schreibwaren und Bürobedarf aus Papier, Karton und Pappe'],
    ['17.24.0', 'Herstellung von Tapeten'],
    ['17.25.0', 'Herstellung von sonstigen Waren aus Papier, Karton und Pappe'],
    ['18.11.0', 'Drucken von Zeitungen'],
    ['18.12.0', 'Sonstiges Drucken'],
    ['18.13.0', 'Druck- und Medienvorstufe'],
    ['18.14.0', 'Binden von Druckerzeugnissen und damit verbundene Dienstleistungen'],
    ['18.20.0', 'Vervielfältigung von bespielten Ton-, Bild- und Datenträgern'],
    ['19.10.0', 'Kokerei'],
    ['19.20.0', 'Herstellung von Mineralölerzeugnissen und von fossilen Brennstoffen'],
    ['20.11.0', 'Herstellung von Industriegasen'],
    ['20.12.0', 'Herstellung von Farbstoffen und Pigmenten'],
    ['20.13.0', 'Herstellung von sonstigen anorganischen Grundstoffen und Chemikalien'],
    ['20.14.0', 'Herstellung von sonstigen organischen Grundstoffen und Chemikalien'],
    ['20.15.0', 'Herstellung von Düngemitteln und Stickstoffverbindungen'],
    ['20.16.0', 'Herstellung von Kunststoffen in Primärformen'],
    ['20.17.0', 'Herstellung von synthetischem Kautschuk in Primärformen'],
    ['20.20.0', 'Herstellung von Schädlingsbekämpfungs-, Pflanzenschutz- und Desinfektionsmitteln'],
    ['20.30.0', 'Herstellung von Anstrichmitteln, Druckfarben und Kitten'],
    ['20.41.0', 'Herstellung von Seifen, Wasch-, Reinigungs- und Poliermitteln'],
    ['20.42.0', 'Herstellung von Körperpflegemitteln und Duftstoffen'],
    ['20.51.0', 'Herstellung von flüssigen Biokraftstoffen'],
    ['20.59.1', 'Herstellung von pyrotechnischen Erzeugnissen'],
    ['20.59.2', 'Herstellung von Klebstoffen'],
    ['20.59.3', 'Herstellung von ätherischen Ölen'],
    ['20.59.9', 'Herstellung von sonstigen chemischen Erzeugnissen a. n. g.'],
    ['20.60.0', 'Herstellung von Chemiefasern'],
    ['21.10.0', 'Herstellung von pharmazeutischen Grundstoffen'],
    [
        '21.20.0',
        'Herstellung von pharmazeutischen Spezialitäten und sonstigen pharmazeutischen Erzeugnissen',
    ],
    ['22.11.0', 'Herstellung und Runderneuerung von Bereifungen'],
    ['22.12.1', 'Herstellung von Kautschuk, Kautschukmischungen und Halbzeug daraus'],
    ['22.12.9', 'Herstellung von sonstigen Gummiwaren a. n. g.'],
    ['22.21.0', 'Herstellung von Platten, Folien, Schläuchen und Profilen aus Kunststoffen'],
    ['22.22.0', 'Herstellung von Verpackungsmitteln aus Kunststoffen'],
    ['22.23.0', 'Herstellung von Türen und Fenstern aus Kunststoffen'],
    ['22.24.0', 'Herstellung von Baubedarfsartikeln aus Kunststoffen'],
    ['22.25.0', 'Bearbeitung und Veredlung von Kunststoffwaren'],
    ['22.26.1', 'Herstellung von Haushalts- oder Hauswirtschaftsartikeln aus Kunststoffen'],
    ['22.26.2', 'Herstellung von Büro- oder Schulartikeln aus Kunststoffen'],
    ['22.26.9', 'Herstellung von sonstigen Kunststoffwaren a. n. g.'],
    ['23.11.0', 'Herstellung von Flachglas'],
    ['23.12.0', 'Veredlung und Bearbeitung von Flachglas'],
    ['23.13.1', 'Herstellung von Flaschen und anderen Behältnissen aus Glas'],
    ['23.13.9', 'Herstellung von Trinkgläsern und anderen Haushaltswaren aus Glas a. n. g.'],
    ['23.14.0', 'Herstellung von Glasfasern und Waren daraus'],
    [
        '23.15.0',
        'Herstellung, Veredlung und Bearbeitung von sonstigem Glas einschließlich technischen Glaswaren',
    ],
    ['23.20.0', 'Herstellung von feuerfesten keramischen Werkstoffen und Waren'],
    ['23.31.0', 'Herstellung von keramischen Wand- und Bodenfliesen und -platten'],
    ['23.32.0', 'Herstellung von Ziegeln und sonstiger Baukeramik'],
    ['23.41.0', 'Herstellung von keramischen Haushaltswaren und Ziergegenständen'],
    ['23.42.0', 'Herstellung von Sanitärkeramik'],
    ['23.43.0', 'Herstellung von Isolatoren und Isolierteilen aus Keramik'],
    ['23.44.0', 'Herstellung von keramischen Erzeugnissen für sonstige technische Zwecke'],
    ['23.45.0', 'Herstellung von sonstigen keramischen Erzeugnissen'],
    ['23.51.0', 'Herstellung von Zement'],
    ['23.52.0', 'Herstellung von Kalk und gebranntem Gips'],
    ['23.61.1', 'Herstellung von Baublöcken und Mauersteinen aus Kalksandstein oder Porenbeton'],
    [
        '23.61.2',
        'Herstellung von Baublöcken und Mauersteinen aus sonstigem Beton, von Dachsteinen, Steinplatten und dergleichen aus Beton, Zement oder Kalksandstein',
    ],
    [
        '23.61.3',
        'Herstellung von vorgefertigten Bauelementen und Gebäuden aus Beton, Zement oder Kalksandstein',
    ],
    ['23.62.0', 'Herstellung von Gipserzeugnissen für den Bau'],
    ['23.63.0', 'Herstellung von Frischbeton, Transportbeton'],
    ['23.64.0', 'Herstellung von Mörtel und sonstigem Beton, ohne Frischbeton'],
    ['23.65.0', 'Herstellung von Faserzementwaren'],
    ['23.66.0', 'Herstellung von sonstigen Erzeugnissen aus Beton, Zement und Gips'],
    ['23.70.0', 'Be- und Verarbeitung von Naturwerksteinen und Natursteinen'],
    ['23.91.0', 'Herstellung von Schleifkörpern und Schleifmitteln auf Unterlage'],
    ['23.99.0', 'Herstellung von sonstigen Erzeugnissen aus nichtmetallischen Mineralien a. n. g.'],
    ['24.10.0', 'Erzeugung von Roheisen, Stahl und Ferrolegierungen'],
    ['24.20.1', 'Herstellung von Stahlrohren (ohne Präzisionsstahlrohre)'],
    ['24.20.2', 'Herstellung von Präzisionsstahlrohren'],
    ['24.20.3', 'Herstellung von Rohrform-, Rohrverschluss- und Rohrverbindungsstücken aus Stahl'],
    ['24.31.0', 'Herstellung von Blankstahl'],
    ['24.32.0', 'Herstellung von Kaltband mit einer Breite von weniger als 600 mm'],
    ['24.33.0', 'Herstellung von Kaltprofilen'],
    ['24.34.0', 'Herstellung von kaltgezogenem Draht'],
    ['24.41.0', 'Erzeugung und erste Bearbeitung von Edelmetallen'],
    ['24.42.0', 'Erzeugung und erste Bearbeitung von Aluminium'],
    ['24.43.0', 'Erzeugung und erste Bearbeitung von Blei, Zink und Zinn'],
    ['24.44.0', 'Erzeugung und erste Bearbeitung von Kupfer'],
    ['24.45.0', 'Erzeugung und erste Bearbeitung von sonstigen NE-Metallen'],
    ['24.46.0', 'Aufbereitung von Kernbrennstoffen'],
    ['24.51.1', 'Graugießereien'],
    ['24.51.9', 'Eisengießereien a. n. g.'],
    ['24.52.0', 'Stahlgießereien'],
    ['24.53.0', 'Leichtmetallgießereien'],
    ['24.54.0', 'Buntmetallgießereien'],
    ['25.11.0', 'Herstellung von Metallkonstruktionen'],
    ['25.12.0', 'Herstellung von Ausbauelementen aus Metall'],
    ['25.21.1', 'Herstellung von Heizkörpern für Zentralheizungen'],
    ['25.21.2', 'Herstellung von Dampfkesseln und Kesseln zum Erzeugen von überhitztem Wasser'],
    ['25.22.0', 'Herstellung von Sammelbehältern, Tanks u. ä. Behältern aus Metall'],
    ['25.30.0', 'Herstellung von Waffen und Munition'],
    ['25.40.1', 'Herstellung von Freiformschmiedestücken'],
    ['25.40.2', 'Herstellung von Gesenkschmiedeteilen'],
    ['25.40.3', 'Herstellung von Kaltfließpressteilen'],
    ['25.40.4', 'Herstellung von Press-, Zieh- und Stanzteilen'],
    ['25.40.5', 'Herstellung von pulvermetallurgischen Erzeugnissen'],
    ['25.51.0', 'Beschichten von Metallen'],
    ['25.52.0', 'Wärmebehandlung von Metallen'],
    ['25.53.0', 'Metallbearbeitung a. n. g.'],
    ['25.61.0', 'Herstellung von Schneidwaren und Bestecken aus unedlen Metallen'],
    ['25.62.0', 'Herstellung von Schlössern und Beschlägen aus unedlen Metallen'],
    ['25.63.1', 'Herstellung von Handwerkzeugen'],
    ['25.63.2', 'Herstellung von Sägen und von Maschinenwerkzeugen für die Holzbearbeitung'],
    ['25.63.3', 'Herstellung von auswechselbaren Werkzeugen für die Metallbearbeitung a. n. g.'],
    ['25.63.4', 'Herstellung von Geräten für Landwirtschaft, Gartenbau und Forstwirtschaft'],
    ['25.63.9', 'Herstellung sonstiger Werkzeuge a. n. g.'],
    ['25.91.0', 'Herstellung von Fässern, Trommeln, Dosen, Eimern u. ä. Behältern aus Metall'],
    ['25.92.0', 'Herstellung von Verpackungen und Verschlüssen aus Eisen, Stahl und NE-Metall'],
    ['25.93.0', 'Herstellung von Drahtwaren, Ketten und Federn'],
    ['25.94.0', 'Herstellung von Schrauben und Nieten'],
    ['25.99.1', 'Herstellung von nicht elektrischen Haushaltsartikeln aus Metall'],
    ['25.99.9', 'Herstellung von allen anderen Metallwaren a. n. g.'],
    ['26.11.1', 'Herstellung von Solarzellen und Solarmodulen'],
    ['26.11.9', 'Herstellung von elektronischen Bauelementen a. n. g.'],
    ['26.12.0', 'Herstellung von bestückten Leiterplatten'],
    ['26.20.0', 'Herstellung von Datenverarbeitungsgeräten und peripheren Geräten'],
    ['26.30.0', 'Herstellung von Geräten und Einrichtungen der Telekommunikationstechnik'],
    ['26.40.0', 'Herstellung von Geräten der Unterhaltungselektronik'],
    [
        '26.51.1',
        'Herstellung von elektrischen Mess-, Kontroll-, Navigations- u. ä. Instrumenten und Vorrichtungen',
    ],
    [
        '26.51.2',
        'Herstellung von nicht elektrischen Mess-, Kontroll-, Navigations- u. ä. Instrumenten und Vorrichtungen',
    ],
    ['26.51.3', 'Herstellung von Prüfmaschinen'],
    ['26.52.0', 'Herstellung von Uhren'],
    [
        '26.60.0',
        'Herstellung von Bestrahlungs- und Elektrotherapiegeräten und elektromedizinischen Geräten',
    ],
    ['26.70.1', 'Herstellung von optischen und fotografischen Instrumenten und Geräten'],
    ['26.70.2', 'Herstellung von magnetischen und optischen Datenträgern'],
    ['27.11.1', 'Herstellung von Elektromotoren und Generatoren'],
    ['27.11.2', 'Herstellung von Transformatoren und Stromrichtern'],
    ['27.12.0', 'Herstellung von Elektrizitätsverteilungs- und -schalteinrichtungen'],
    ['27.20.0', 'Herstellung von Batterien und Akkumulatoren'],
    ['27.31.0', 'Herstellung von Glasfaserkabeln'],
    ['27.32.0', 'Herstellung von sonstigen elektronischen und elektrischen Drähten und Kabeln'],
    ['27.33.0', 'Herstellung von elektrischem Installationsmaterial'],
    ['27.40.0', 'Herstellung von Lampen und Leuchten'],
    ['27.51.0', 'Herstellung von elektrischen Haushaltsgeräten'],
    ['27.52.0', 'Herstellung von nichtelektrischen Haushaltsgeräten'],
    ['27.90.0', 'Herstellung von sonstigen elektrischen Ausrüstungen und Geräten'],
    ['28.11.1', 'Herstellung von Verbrennungsmotoren, ohne Motoren für Luft- und Straßenfahrzeuge'],
    ['28.11.2', 'Herstellung von Turbinen'],
    ['28.12.0', 'Herstellung von hydraulischen und pneumatischen Komponenten und Systemen'],
    ['28.13.0', 'Herstellung von sonstigen Pumpen und Kompressoren'],
    ['28.14.0', 'Herstellung von sonstigen Armaturen'],
    ['28.15.0', 'Herstellung von Lagern, Getrieben, Zahnrädern und Antriebselementen'],
    ['28.21.1', 'Herstellung von Solarwärmekollektoren'],
    ['28.21.2', 'Herstellung von Wärmepumpen'],
    [
        '28.21.9',
        'Herstellung von Öfen und Brennern sowie von ortsfesten Heizgeräten für den Haushalt a. n. g.',
    ],
    ['28.22.0', 'Herstellung von Hebezeugen und Fördermitteln'],
    ['28.23.0', 'Herstellung von Büromaschinen, ohne Datenverarbeitungsgeräte und periphere Geräte'],
    ['28.24.0', 'Herstellung von handgeführten Werkzeugen mit Motorantrieb'],
    ['28.25.0', 'Herstellung von kälte- und lufttechnischen Erzeugnissen, nicht für den Haushalt'],
    ['28.29.0', 'Herstellung von sonstigen nicht wirtschaftszweigspezifischen Maschinen a. n. g.'],
    ['28.30.0', 'Herstellung von land- und forstwirtschaftlichen Maschinen'],
    ['28.41.0', 'Herstellung von Werkzeugmaschinen für die Metallbearbeitung'],
    [
        '28.42.1',
        'Herstellung von Werkzeugmaschinen zur Bearbeitung von Steinen, Beton und sonstigen mineralischen Stoffen',
    ],
    ['28.42.2', 'Herstellung von Werkzeugmaschinen zur Bearbeitung von sonstigen harten Stoffen'],
    ['28.42.3', 'Herstellung von Maschinenspannzeugen und sonstigem Zubehör für Werkzeugmaschinen'],
    ['28.42.9', 'Herstellung von sonstigen Werkzeugmaschinen a. n. g.'],
    [
        '28.91.0',
        'Herstellung von Maschinen für die Metallerzeugung, von Walzwerkseinrichtungen und Gießmaschinen',
    ],
    ['28.92.1', 'Herstellung von Bergwerksmaschinen'],
    ['28.92.2', 'Herstellung von Bau- und Baustoffmaschinen'],
    [
        '28.93.0',
        'Herstellung von Maschinen für die Nahrungs- und Genussmittelerzeugung und die Tabakverarbeitung',
    ],
    [
        '28.94.0',
        'Herstellung von Maschinen für die Textil- und Bekleidungsherstellung und die Lederverarbeitung',
    ],
    ['28.95.0', 'Herstellung von Maschinen für die Papiererzeugung und -verarbeitung'],
    ['28.96.0', 'Herstellung von Maschinen für die Verarbeitung von Kunststoffen und Kautschuk'],
    ['28.97.0', 'Herstellung von Maschinen für die additive Fertigung'],
    ['28.99.1', 'Herstellung von Mehrzweckindustrierobotern'],
    [
        '28.99.9',
        'Herstellung von allen anderen Maschinen für sonstige bestimmte Wirtschaftszweige a. n. g.',
    ],
    ['29.10.1', 'Herstellung von Personenkraftwagen und Personenkraftwagenmotoren'],
    ['29.10.2', 'Herstellung von Nutzkraftwagen und Nutzkraftwagenmotoren'],
    ['29.20.0', 'Herstellung von Karosserien, Aufbauten und Anhängern'],
    ['29.31.0', 'Herstellung elektrischer und elektronischer Ausrüstungsgegenstände für Kraftwagen'],
    ['29.32.0', 'Herstellung von sonstigen Teilen und sonstigem Zubehör für Kraftwagen'],
    [
        '30.11.0',
        'Bau von Schiffen und schwimmenden Vorrichtungen für zivile Zwecke, ohne Boots- und Yachtbau',
    ],
    ['30.12.0', 'Boots- und Yachtbau'],
    ['30.13.0', 'Bau von Kriegsschiffen'],
    ['30.20.1', 'Herstellung von Lokomotiven und anderen Schienenfahrzeugen'],
    [
        '30.20.2',
        'Herstellung von mechanischen oder elektromechanischen Signal-, Sicherungs-, Überwachungs- oder Steuergeräten für Schienenwege oder andere Verkehrswege',
    ],
    ['30.31.0', 'Luft- und Raumfahrzeugbau für zivile Zwecke'],
    ['30.32.0', 'Luft- und Raumfahrzeugbau für militärische Zwecke'],
    ['30.40.0', 'Herstellung von militärischen Kampffahrzeugen'],
    ['30.91.0', 'Herstellung von Krafträdern'],
    ['30.92.0', 'Herstellung von Fahrrädern sowie von Behindertenfahrzeugen'],
    ['30.99.0', 'Herstellung von sonstigen Beförderungsmitteln a. n. g.'],
    ['31.00.1', 'Herstellung von Büromöbeln'],
    ['31.00.2', 'Herstellung von Ladenmöbeln und sonstigen Objektmöbeln'],
    ['31.00.3', 'Herstellung von Küchenmöbeln'],
    ['31.00.4', 'Herstellung von Matratzen'],
    ['31.00.5', 'Herstellung von Polstermöbeln'],
    ['31.00.6', 'Herstellung von Schlaf-, Ess- und Wohnzimmermöbeln'],
    ['31.00.9', 'Herstellung von Möbeln a. n. g.'],
    ['32.11.0', 'Herstellung von Münzen'],
    ['32.12.0', 'Herstellung von Schmuck, Gold- und Silberschmiedewaren, ohne Fantasieschmuck'],
    ['32.13.0', 'Herstellung von Fantasieschmuck'],
    ['32.20.0', 'Herstellung von Musikinstrumenten'],
    ['32.30.0', 'Herstellung von Sportgeräten'],
    ['32.40.0', 'Herstellung von Spielwaren'],
    ['32.50.1', 'Herstellung von orthopädischen Erzeugnissen'],
    ['32.50.2', 'Zahntechnische Laboratorien'],
    [
        '32.50.3',
        'Herstellung von medizinischen und zahnmedizinischen Apparaten und Materialien a. n. g.',
    ],
    ['32.91.0', 'Herstellung von Besen und Bürsten'],
    ['32.99.0', 'Herstellung von sonstigen Erzeugnissen a. n. g.'],
    ['33.11.0', 'Reparatur und Instandhaltung von Metallerzeugnissen'],
    ['33.12.0', 'Reparatur und Instandhaltung von Maschinen'],
    ['33.13.0', 'Reparatur und Instandhaltung von elektronischen und optischen Geräten'],
    ['33.14.0', 'Reparatur und Instandhaltung von elektrischen Ausrüstungen'],
    ['33.15.0', 'Reparatur und Instandhaltung von zivilen Schiffen, Booten und Yachten'],
    ['33.16.0', 'Reparatur und Instandhaltung von zivilen Luft- und Raumfahrzeugen'],
    ['33.17.1', 'Reparatur und Instandhaltung von Schienenfahrzeugen'],
    ['33.17.9', 'Reparatur und Instandhaltung von sonstigen zivilen Beförderungsmitteln a. n. g.'],
    ['33.18.1', 'Reparatur und Instandhaltung von militärischen Kampffahrzeugen'],
    ['33.18.2', 'Reparatur und Instandhaltung von Kriegsschiffen'],
    ['33.18.3', 'Reparatur und Instandhaltung von militärischen Luft- und Raumfahrzeugen'],
    ['33.19.0', 'Reparatur und Instandhaltung von sonstigen Ausrüstungen'],
    ['33.20.0', 'Installation von Industriemaschinen und -ausrüstungen'],
    ['35.11.1', 'Elektrizitätserzeugung aus nicht erneuerbaren Energieträgern ohne Verteilung'],
    ['35.11.2', 'Elektrizitätserzeugung aus nicht erneuerbaren Energieträgern zur Verteilung'],
    ['35.12.1', 'Elektrizitätserzeugung aus erneuerbaren Energieträgern ohne Verteilung'],
    ['35.12.2', 'Elektrizitätserzeugung aus erneuerbaren Energieträgern zur Verteilung'],
    ['35.13.0', 'Elektrizitätsübertragung'],
    ['35.14.0', 'Elektrizitätsverteilung'],
    ['35.15.0', 'Elektrizitätshandel'],
    ['35.16.0', 'Speichern von elektrischer Energie'],
    ['35.21.1', 'Gaserzeugung aus nicht erneuerbaren Energieträgern'],
    ['35.21.2', 'Gaserzeugung aus erneuerbaren Energieträgern'],
    ['35.22.0', 'Gasverteilung durch Rohrleitungen'],
    ['35.23.0', 'Gashandel durch Rohrleitungen'],
    ['35.24.0', 'Speichern von Gas zu Versorgungszwecken'],
    ['35.30.1', 'Wärme- und Kälteerzeugung'],
    ['35.30.2', 'Wärme- und Kälteverteilung'],
    ['35.30.3', 'Wärme- und Kältehandel'],
    ['35.30.4', 'Wärme- und Kältespeicherung'],
    ['35.40.0', 'Tätigkeiten von Strom- und Erdgasmaklerinnen und -maklern'],
    ['36.00.1', 'Wassergewinnung mit Fremdbezug zur Verteilung'],
    ['36.00.2', 'Wassergewinnung ohne Fremdbezug zur Verteilung'],
    ['36.00.3', 'Wasserverteilung ohne Gewinnung'],
    ['37.00.1', 'Betrieb der Sammelkanalisation'],
    ['37.00.2', 'Betrieb von Kläranlagen'],
    ['38.11.0', 'Sammlung nicht gefährlicher Abfälle'],
    ['38.12.0', 'Sammlung gefährlicher Abfälle'],
    ['38.21.1', 'Zerlegen von Schiffs- und Fahrzeugwracks und anderen Altwaren'],
    ['38.21.2', 'Rückgewinnung sortierter Werkstoffe'],
    ['38.22.0', 'Energetische Verwertung von Abfällen'],
    ['38.23.0', 'Sonstige Verwertung von Abfällen'],
    ['38.31.0', 'Verbrennung von Abfällen ohne energetische Verwertung'],
    ['38.32.1', 'Deponierung oder Dauerlagerung von hoch radioaktiven Abfällen'],
    ['38.32.2', 'Deponierung oder Dauerlagerung von sonstigen Abfällen'],
    ['38.33.0', 'Sonstige Beseitigung von Abfällen'],
    ['39.00.1', 'Dekontaminierung von Nuklearanlagen und -standorten'],
    ['39.00.2', 'Beseitigung von Umweltverschmutzungen an Gebäuden'],
    [
        '39.00.3',
        'Beseitigung von anderen Umweltverschmutzungen und sonstige Tätigkeiten in der Abfallbewirtschaftung',
    ],
    ['41.00.1', 'Bau von Gebäuden (ohne Fertigteilbau)'],
    ['41.00.2', 'Errichtung von Fertigteilbauten'],
    ['42.11.0', 'Bau von Straßen'],
    ['42.12.0', 'Bau von Bahnverkehrsstrecken'],
    ['42.13.0', 'Brücken- und Tunnelbau'],
    ['42.21.0', 'Rohrleitungstiefbau, Brunnenbau und Kläranlagenbau'],
    ['42.22.0', 'Bau von Versorgungseinrichtungen für Elektrizität und Telekommunikation'],
    ['42.91.0', 'Wasserbau'],
    ['42.99.1', 'Bau von Industrieanlagen, außer Gebäuden'],
    ['42.99.9', 'Sonstiger Tiefbau a. n. g. (ohne Bau von Industrieanlagen)'],
    ['43.11.0', 'Abbrucharbeiten'],
    ['43.12.0', 'Vorbereitende Baustellenarbeiten'],
    ['43.13.0', 'Test- und Suchbohrung'],
    ['43.21.0', 'Elektroinstallation'],
    ['43.22.0', 'Gas-, Wasser-, Heizungs- sowie Lüftungs- und Klimainstallation'],
    ['43.23.0', 'Einbau von Isolierungen'],
    ['43.24.0', 'Sonstige Bauinstallation'],
    ['43.31.0', 'Anbringen von Stuckaturen, Gipserei und Verputzerei'],
    ['43.32.1', 'Montage, Installation und Aufbau von Ständen auf Märkten, Ausstellungen und Messen'],
    ['43.32.2', 'Sonstige Bautischlerei und -schlosserei'],
    ['43.33.0', 'Fußboden-, Fliesen- und Plattenlegerei, Tapeziererei'],
    ['43.34.1', 'Malerei- und Lackiergewerbe'],
    ['43.34.2', 'Glasergewerbe'],
    ['43.35.0', 'Sonstiger Ausbau'],
    ['43.41.1', 'Dachdeckerei und Bauspenglerei'],
    ['43.41.2', 'Zimmerei und Ingenieurholzbau'],
    ['43.42.1', 'Schornstein-, Feuerungs- und Industrieofenbau'],
    ['43.42.9', 'Sonstige spezialisierte Bautätigkeiten im Hochbau a. n. g.'],
    ['43.50.0', 'Spezialisierte Bautätigkeiten im Tiefbau'],
    ['43.60.0', 'Vermittlungstätigkeiten für spezialisierte Bautätigkeiten'],
    ['43.91.0', 'Maurerarbeiten'],
    ['43.99.1', 'Gerüstbau'],
    ['43.99.9', 'Alle anderen spezialisierten Bautätigkeiten a. n. g.'],
    [
        '46.11.0',
        'Tätigkeiten der Großhandelsvermittlung von landwirtschaftlichen Grundstoffen, lebenden Tieren, textilen Rohstoffen und Halbwaren',
    ],
    [
        '46.12.0',
        'Tätigkeiten der Großhandelsvermittlung von Brennstoffen, Erzen, Metallen und technischen Chemikalien',
    ],
    [
        '46.13.1',
        'Tätigkeiten der Großhandelsvermittlung von Rohholz, Holzhalbwaren und Bauelementen aus Holz',
    ],
    ['46.13.2', 'Tätigkeiten der Großhandelsvermittlung von Baustoffen und Anstrichmitteln'],
    [
        '46.13.3',
        'Tätigkeiten der Großhandelsvermittlung von Installationsbedarf für Gas, Wasser, Heizung und Klimatechnik',
    ],
    ['46.14.1', 'Tätigkeiten der Großhandelsvermittlung von Wasser- und Luftfahrzeugen'],
    [
        '46.14.2',
        'Tätigkeiten der Großhandelsvermittlung von Büromaschinen, Datenverarbeitungsgeräten, peripheren Geräten und Software',
    ],
    [
        '46.14.3',
        'Tätigkeiten der Großhandelsvermittlung von Telekommunikationsgeräten sowie elektrotechnischen und elektronischen Erzeugnissen a. n. g.',
    ],
    [
        '46.14.4',
        'Tätigkeiten der Großhandelsvermittlung von landwirtschaftlichen Maschinen und Geräten',
    ],
    [
        '46.14.9',
        'Tätigkeiten der Großhandelsvermittlung von Maschinen (ohne landwirtschaftliche Maschinen und Büromaschinen) und technischem Bedarf a. n. g.',
    ],
    ['46.15.1', 'Tätigkeiten der Großhandelsvermittlung von Möbeln'],
    [
        '46.15.2',
        'Tätigkeiten der Großhandelsvermittlung von keramischen Erzeugnissen, Glaswaren, Holzwaren a. n. g., sowie Flecht- und Korbwaren',
    ],
    ['46.15.3', 'Tätigkeiten der Großhandelsvermittlung von Geräten der Unterhaltungselektronik'],
    ['46.15.4', 'Tätigkeiten der Großhandelsvermittlung von elektrischen Haushaltsgeräten'],
    ['46.15.5', 'Tätigkeiten der Großhandelsvermittlung von Werkzeugen'],
    [
        '46.15.6',
        'Tätigkeiten der Großhandelsvermittlung von Eisen-, Metall- und Kunststoffwaren a. n. g.',
    ],
    ['46.15.9', 'Tätigkeiten der Großhandelsvermittlung von Einrichtungsgegenständen a. n. g.'],
    ['46.16.1', 'Tätigkeiten der Großhandelsvermittlung von Bekleidung und Bekleidungszubehör'],
    ['46.16.2', 'Tätigkeiten der Großhandelsvermittlung von Schuhen, Lederwaren und Reisegepäck'],
    ['46.16.3', 'Tätigkeiten der Großhandelsvermittlung von sonstigen Textilien'],
    ['46.17.1', 'Tätigkeiten der Großhandelsvermittlung von Wein, Sekt und Spirituosen'],
    [
        '46.17.2',
        'Tätigkeiten der Großhandelsvermittlung von sonstigen Nahrungsmitteln, Getränken und Tabakwaren',
    ],
    ['46.18.1', 'Tätigkeiten der Großhandelsvermittlung von Kraftwagen'],
    ['46.18.2', 'Tätigkeiten der Großhandelsvermittlung von Kraftwagenteilen und -zubehör'],
    [
        '46.18.3',
        'Tätigkeiten der Großhandelsvermittlung von Krafträdern, Kraftradteilen und -zubehör',
    ],
    [
        '46.18.4',
        'Tätigkeiten der Großhandelsvermittlung von feinmechanischen, Foto- und optischen Erzeugnissen, Uhren, Edelmetallwaren und Schmuck',
    ],
    ['46.18.5', 'Tätigkeiten der Großhandelsvermittlung von Spielwaren und Musikinstrumenten'],
    [
        '46.18.6',
        'Tätigkeiten der Großhandelsvermittlung von pharmazeutischen Erzeugnissen, medizinischen Artikeln, Krankenhaus-, Dental- und Altenpflegebedarf',
    ],
    [
        '46.18.7',
        'Tätigkeiten der Großhandelsvermittlung von kosmetischen Erzeugnissen, Körperpflegemitteln, Putz- und Reinigungsmitteln',
    ],
    [
        '46.18.8',
        'Tätigkeiten der Großhandelsvermittlung von Papier, Karton, Schreibwaren, Bürobedarf, Büchern, Zeitungen und sonstigen Druckerzeugnissen',
    ],
    ['46.18.9', 'Tätigkeiten der Großhandelsvermittlung von sonstigen Waren a. n. g.'],
    ['46.19.0', 'Tätigkeiten der Großhandelsvermittlung von Waren ohne ausgeprägten Schwerpunkt'],
    ['46.21.0', 'Großhandel mit Getreide, Rohtabak, Saatgut und Futtermitteln'],
    ['46.22.0', 'Großhandel mit Blumen und Pflanzen'],
    ['46.23.0', 'Großhandel mit lebenden Tieren'],
    ['46.24.0', 'Großhandel mit Häuten, Fellen und Leder'],
    ['46.31.0', 'Großhandel mit Obst, Gemüse und Kartoffeln'],
    ['46.32.1', 'Großhandel mit Fleisch und Fleischwaren'],
    ['46.32.2', 'Großhandel mit Fisch und Fischerzeugnissen'],
    ['46.33.0', 'Großhandel mit Milch, Milcherzeugnissen, Eiern, Speiseölen und Nahrungsfetten'],
    ['46.34.0', 'Großhandel mit Getränken'],
    ['46.35.0', 'Großhandel mit Tabakwaren'],
    ['46.36.0', 'Großhandel mit Zucker, Süßwaren und Backwaren'],
    ['46.37.0', 'Großhandel mit Kaffee, Tee, Kakao und Gewürzen'],
    ['46.38.1', 'Großhandel mit Mehl und Getreideprodukten'],
    ['46.38.9', 'Großhandel mit sonstigen Nahrungs- und Genussmitteln a. n. g.'],
    [
        '46.39.0',
        'Großhandel mit Nahrungs- und Genussmitteln, Getränken und Tabakwaren, ohne ausgeprägten Schwerpunkt',
    ],
    ['46.41.0', 'Großhandel mit Textilien'],
    ['46.42.1', 'Großhandel mit Bekleidung'],
    ['46.42.2', 'Großhandel mit Schuhen'],
    ['46.43.1', 'Großhandel mit Foto- und optischen Erzeugnissen'],
    ['46.43.2', 'Großhandel mit elektrischen Haushaltsgeräten'],
    ['46.43.3', 'Großhandel mit Geräten der Unterhaltungselektronik'],
    ['46.44.1', 'Großhandel mit keramischen Erzeugnissen und Glaswaren'],
    ['46.44.2', 'Großhandel mit Wasch-, Putz- und Reinigungsmitteln'],
    ['46.45.0', 'Großhandel mit kosmetischen Erzeugnissen und Körperpflegemitteln'],
    ['46.46.1', 'Großhandel mit pharmazeutischen Erzeugnissen'],
    ['46.46.2', 'Großhandel mit medizinischen und orthopädischen Artikeln, Dental- und Laborbedarf'],
    ['46.47.0', 'Großhandel mit Möbeln, Teppichen, Lampen und Leuchten'],
    ['46.48.0', 'Großhandel mit Uhren und Schmuck'],
    ['46.49.1', 'Großhandel mit Spielwaren und Musikinstrumenten'],
    ['46.49.2', 'Großhandel mit Fahrrädern, E-Bikes, deren Teilen und Zubehör'],
    ['46.49.3', 'Großhandel mit Campingartikeln (ohne Campingmöbel)'],
    ['46.49.4', 'Großhandel mit Sportartikeln und -zubehör'],
    ['46.49.5', 'Großhandel mit Lederwaren, Reisegepäck, Geschenk- und Werbeartikeln'],
    ['46.49.6', 'Großhandel mit Karton, Papier, Pappe, Schreibwaren und Bürobedarf'],
    [
        '46.49.7',
        'Großhandel mit Büchern, Zeitschriften, Zeitungen sowie bespielten Ton- und Bildträgern',
    ],
    [
        '46.49.9',
        'Großhandel mit nicht elektrischen Haushaltsgeräten, Haushaltswaren aus Metall sowie sonstigen Gebrauchs- und Verbrauchsgütern a. n. g.',
    ],
    ['46.50.1', 'Großhandel mit Datenverarbeitungsgeräten, peripheren Geräten und Software'],
    ['46.50.2', 'Großhandel mit elektronischen Bauteilen und Telekommunikationsgeräten'],
    ['46.50.3', 'Großhandel mit sonstigen Büromaschinen und -einrichtungen'],
    ['46.61.0', 'Großhandel mit landwirtschaftlichen Maschinen und Geräten'],
    ['46.62.0', 'Großhandel mit Werkzeugmaschinen'],
    ['46.63.0', 'Großhandel mit Bergwerks-, Bau- und Baustoffmaschinen'],
    ['46.64.1', 'Großhandel mit industriellen Textil-, Näh- und Strickmaschinen'],
    [
        '46.64.2',
        'Großhandel mit Schiffen und Booten (ohne Freizeitboote) sowie deren Ersatzteilen und Zubehör',
    ],
    ['46.64.3', 'Großhandel mit Flurförderzeugen und Fahrzeugen a. n. g.'],
    ['46.64.4', 'Großhandel mit Photovoltaikmodulen'],
    ['46.64.5', 'Großhandel mit sonstigen Maschinen'],
    [
        '46.64.6',
        'Großhandel mit sonstigen Ausrüstungen und Zubehör für Maschinen sowie mit technischem Bedarf',
    ],
    [
        '46.71.1',
        'Großhandel mit Kraftwagen mit einem zulässigen Gesamtgewicht von 3,5 t oder weniger',
    ],
    ['46.71.2', 'Großhandel mit Kraftwagen mit einem zulässigen Gesamtgewicht von mehr als 3,5 t'],
    ['46.72.0', 'Großhandel mit Kraftwagenteilen und -zubehör'],
    ['46.73.0', 'Großhandel mit Krafträdern, Kraftradteilen und -zubehör'],
    ['46.81.0', 'Großhandel mit Brennstoffen und Mineralölerzeugnissen'],
    ['46.82.1', 'Großhandel mit Eisenerzen, Eisen, Stahl, Eisen- und Stahlhalbzeug'],
    ['46.82.2', 'Großhandel mit NE-Erzen, NE-Metallen und NE-Metallhalbzeug'],
    ['46.83.1', 'Großhandel mit Roh- und Schnittholz'],
    ['46.83.2', 'Großhandel mit sonstigen Holzhalbwaren sowie Bauelementen aus Holz'],
    ['46.83.3', 'Großhandel mit sonstigen Baustoffen und Bauelementen'],
    ['46.83.4', 'Großhandel mit Flachglas'],
    ['46.83.5', 'Großhandel mit Anstrichmitteln'],
    ['46.83.6', 'Großhandel mit Sanitärkeramik'],
    ['46.83.7', 'Großhandel mit Tapeten und Bodenbelägen (ohne Teppiche)'],
    [
        '46.83.8',
        'Großhandel mit Holz, Baustoffen, Anstrichmitteln und Sanitärkeramik, ohne Spezialisierung auf eine der Produktgruppen',
    ],
    ['46.84.1', 'Großhandel mit Werkzeugen und Kleineisenwaren'],
    ['46.84.2', 'Großhandel mit Installationsbedarf für Gas, Wasser und Heizung'],
    ['46.84.9', 'Großhandel mit Metall- und Kunststoffwaren für Bauzwecke a. n. g.'],
    ['46.85.0', 'Großhandel mit chemischen Erzeugnissen'],
    ['46.86.0', 'Großhandel mit sonstigen Halbwaren'],
    ['46.87.0', 'Großhandel mit Altmaterialien und Reststoffen'],
    ['46.89.0', 'Sonstiger Großhandel a. n. g.'],
    ['46.90.1', 'Großhandel mit Fertigwaren, ohne ausgeprägten Schwerpunkt'],
    ['46.90.2', 'Großhandel mit Rohstoffen und Halbwaren, ohne ausgeprägten Schwerpunkt'],
    ['46.90.3', 'Großhandel mit Rohstoffen, Halb- und Fertigwaren, ohne ausgeprägten Schwerpunkt'],
    [
        '47.11.1',
        'Einzelhandel mit Nahrungs- und Genussmitteln und Getränken, ohne ausgeprägten Schwerpunkt',
    ],
    [
        '47.11.2',
        'Sonstiger Einzelhandel mit Waren verschiedener Art, Hauptrichtung Nahrungs- und Genussmittel und Getränken',
    ],
    ['47.12.1', 'Einzelhandel mit Waren verschiedener Art, ohne Nahrungsmittel'],
    ['47.12.2', 'Einzelhandel mit Waren verschiedener Art, Hauptrichtung Nicht-Nahrungsmittel'],
    ['47.21.0', 'Einzelhandel mit Obst, Gemüse und Kartoffeln'],
    ['47.22.0', 'Einzelhandel mit Fleisch und Fleischwaren'],
    ['47.23.0', 'Einzelhandel mit Fisch, Meeresfrüchten und Fischerzeugnissen'],
    ['47.24.0', 'Einzelhandel mit Back- und Süßwaren'],
    ['47.25.0', 'Einzelhandel mit Getränken'],
    ['47.26.0', 'Einzelhandel mit Tabakwaren'],
    ['47.27.0', 'Einzelhandel mit sonstigen Nahrungs- und Genussmitteln'],
    ['47.30.1', 'Einzelhandel in fremdem Namen mit Motorenkraftstoffen, Agenturtankstellen'],
    ['47.30.2', 'Einzelhandel in eigenem Namen mit Motorenkraftstoffen, Freie Tankstellen'],
    ['47.40.1', 'Einzelhandel mit Datenverarbeitungsgeräten, peripheren Geräten und Software'],
    ['47.40.2', 'Einzelhandel mit Telekommunikationsgeräten'],
    ['47.40.3', 'Einzelhandel mit Geräten der Unterhaltungselektronik'],
    ['47.51.0', 'Einzelhandel mit Textilien'],
    ['47.52.0', 'Einzelhandel mit Metallwaren, Anstrichmitteln, Bau- und Heimwerkerbedarf'],
    ['47.53.0', 'Einzelhandel mit Vorhängen, Teppichen, Fußbodenbelägen und Tapeten'],
    ['47.54.0', 'Einzelhandel mit elektrischen Haushaltsgeräten'],
    ['47.55.1', 'Einzelhandel mit Wohnmöbeln'],
    ['47.55.2', 'Einzelhandel mit keramischen Erzeugnissen und Glaswaren'],
    ['47.55.9', 'Einzelhandel mit Haushaltsgegenständen a. n. g.'],
    ['47.61.0', 'Einzelhandel mit Büchern'],
    ['47.62.1', 'Einzelhandel mit Zeitschriften und Zeitungen'],
    ['47.62.2', 'Einzelhandel mit Schreib- und Papierwaren, Schul- und Büroartikeln'],
    ['47.63.1', 'Einzelhandel mit Fahrrädern, E-Bikes, deren Teilen und Zubehör'],
    ['47.63.2', 'Einzelhandel mit Sport- und Campingartikeln (ohne Campingmöbel)'],
    ['47.64.0', 'Einzelhandel mit Spielwaren'],
    ['47.69.1', 'Einzelhandel mit bespielten Ton- und Bildträgern (ohne Audiobooks)'],
    ['47.69.2', 'Einzelhandel mit Musikinstrumenten und Noten'],
    ['47.69.9', 'Einzelhandel mit sonstigen Kunst- und Kulturerzeugnissen a. n. g.'],
    ['47.71.0', 'Einzelhandel mit Bekleidung'],
    ['47.72.1', 'Einzelhandel mit Schuhen'],
    ['47.72.2', 'Einzelhandel mit Lederwaren und Reisegepäck'],
    ['47.73.0', 'Einzelhandel mit pharmazeutischen Erzeugnissen'],
    ['47.74.1', 'Einzelhandel mit Brillen und Kontaktlinsen'],
    ['47.74.2', 'Einzelhandel mit sonstigen medizinischen und orthopädischen Artikeln'],
    ['47.75.0', 'Einzelhandel mit kosmetischen Erzeugnissen und Körperpflegemitteln'],
    ['47.76.1', 'Einzelhandel mit Blumen, Pflanzen, Sämereien und Düngemitteln'],
    ['47.76.2', 'Einzelhandel mit zoologischem Bedarf und lebenden Tieren'],
    ['47.77.0', 'Einzelhandel mit Uhren und Schmuck'],
    ['47.78.1', 'Einzelhandel mit Foto- und optischen Erzeugnissen, ohne Augenoptik'],
    ['47.78.9', 'Einzelhandel mit sonstigen Neuwaren a. n. g.'],
    ['47.79.1', 'Einzelhandel mit Antiquitäten und antiken Teppichen'],
    ['47.79.2', 'Antiquariate'],
    ['47.79.9', 'Einzelhandel mit sonstigen Gebrauchtwaren a. n. g.'],
    [
        '47.81.1',
        'Einzelhandel mit Kraftwagen mit einem zulässigen Gesamtgewicht von 3,5 t oder weniger',
    ],
    ['47.81.2', 'Einzelhandel mit Kraftwagen mit einem zulässigen Gesamtgewicht von mehr als 3,5 t'],
    ['47.82.0', 'Einzelhandel mit Kraftwagenteilen und -zubehör'],
    ['47.83.0', 'Einzelhandel mit Krafträdern, Kraftradteilen und -zubehör'],
    ['47.91.1', 'Versteigerungsgewerbe im Einzelhandel ohne ausgeprägten Schwerpunkt'],
    [
        '47.91.2',
        'Sonstige Vermittlungstätigkeiten für den Einzelhandel ohne ausgeprägten Schwerpunkt',
    ],
    ['47.92.1', 'Versteigerungsgewerbe im Einzelhandel mit ausgeprägtem Schwerpunkt'],
    ['47.92.2', 'Sonstige Vermittlungstätigkeiten für den Einzelhandel mit ausgeprägtem Schwerpunkt'],
    ['49.11.0', 'Personenbeförderung im Eisenbahnverkehr'],
    ['49.12.0', 'Sonstige Personenbeförderung im Schienenverkehr'],
    ['49.20.0', 'Güterbeförderung im Schienenverkehr'],
    ['49.31.0', 'Personenbeförderung im Linienverkehr auf der Straße'],
    ['49.32.0', 'Personenbeförderung im Gelegenheitsverkehr auf der Straße'],
    ['49.33.0', 'Personenbeförderung mit Fahrzeug mit Fahrer auf Abruf'],
    ['49.34.0', 'Personenbeförderung mit Seilbahnen und Skiliften'],
    ['49.39.0', 'Sonstige Personenbeförderung im Landverkehr a. n. g.'],
    ['49.41.0', 'Güterbeförderung im Straßenverkehr'],
    ['49.42.0', 'Umzugstransporte'],
    ['49.50.1', 'Transport von Gas zur Energieversorgung in Rohrfernleitungen'],
    ['49.50.2', 'Sonstiger Transport in Rohrfernleitungen'],
    ['50.10.0', 'Personenbeförderung in der Hochsee- und Küstenschifffahrt'],
    ['50.20.0', 'Güterbeförderung in der Hochsee- und Küstenschifffahrt'],
    ['50.30.0', 'Personenbeförderung in der Binnenschifffahrt'],
    ['50.40.0', 'Güterbeförderung in der Binnenschifffahrt'],
    ['51.10.0', 'Personenbeförderung in der Luftfahrt'],
    ['51.21.0', 'Güterbeförderung in der Luftfahrt'],
    ['51.22.0', 'Raumtransport'],
    ['52.10.0', 'Lagerei'],
    ['52.21.1', 'Betrieb von Parkhäusern und Parkplätzen'],
    ['52.21.2', 'Betrieb von Verkehrswegen für Straßenfahrzeuge'],
    ['52.21.3', 'Betrieb von Verkehrswegen für Schienenfahrzeuge'],
    ['52.21.4', 'Betrieb von Bahnhöfen für den Personenverkehr einschließlich Omnibusbahnhöfen'],
    ['52.21.9', 'Erbringung von sonstigen Dienstleistungen für den Landverkehr a. n. g.'],
    ['52.22.1', 'Betrieb von Häfen'],
    ['52.22.9', 'Erbringung von sonstigen Dienstleistungen für die Schifffahrt a. n. g.'],
    ['52.23.1', 'Betrieb von Flughäfen und Landeplätzen für Luftfahrzeuge'],
    ['52.23.9', 'Erbringung von sonstigen Dienstleistungen für die Luftfahrt a. n. g.'],
    ['52.24.0', 'Frachtumschlag'],
    ['52.25.0', 'Erbringung von Logistikdienstleistungen'],
    ['52.26.1', 'Speditionen'],
    ['52.26.9', 'Erbringung von sonstigen Dienstleistungen für den Verkehr a. n. g.'],
    ['52.31.0', 'Vermittlungstätigkeiten für die Güterbeförderung'],
    ['52.32.0', 'Vermittlungstätigkeiten für die Personenbeförderung'],
    ['53.10.0', 'Postdienste von Universaldienstleistungsanbietern'],
    ['53.20.1', 'Briefdienste'],
    ['53.20.2', 'Paket- und Expressdienste'],
    ['53.20.3', 'Kurierdienste'],
    ['53.20.4', 'Lieferdienste'],
    ['53.20.9', 'Sonstige Post-, Kurier- und Expressdienste a. n. g.'],
    ['53.30.0', 'Vermittlungstätigkeiten für Post-, Kurier- und Expressdienstleistungen'],
    ['55.10.1', 'Hotels (ohne Hotels garnis)'],
    ['55.10.2', 'Hotels garnis'],
    ['55.10.3', 'Gasthöfe'],
    ['55.10.4', 'Pensionen'],
    ['55.20.1', 'Erholungs- und Ferienheime'],
    ['55.20.2', 'Ferienzimmer, Ferienwohnungen, Ferienhäuser und Feriendörfer'],
    ['55.20.3', 'Jugendherbergen, Hostels und Hütten'],
    ['55.30.1', 'Camping- und Biwakplätze'],
    ['55.30.2', 'Stellplätze für Wohnmobile'],
    ['55.40.0', 'Vermittlungstätigkeiten für Beherbergungsdienstleistungen'],
    ['55.90.0', 'Sonstige Beherbergungsstätten'],
    ['56.11.1', 'Restaurants mit Bedienung'],
    ['56.11.2', 'Restaurants mit Selbstbedienung'],
    ['56.11.3', 'Imbissstuben u. Ä.'],
    ['56.11.4', 'Cafés'],
    ['56.11.5', 'Eissalons'],
    ['56.12.1', 'Mobile Gastronomie auf Jahrmärkten u. Ä.'],
    ['56.12.2', 'Sonstige mobile Gastronomie'],
    ['56.21.0', 'Event-Caterer'],
    ['56.22.0', 'Sonstige Caterer und Erbringung sonstiger Verpflegungsdienstleistungen'],
    ['56.30.1', 'Schankwirtschaften'],
    ['56.30.2', 'Diskotheken und Tanzlokale mit Getränkeausschank'],
    ['56.30.3', 'Bars und Vergnügungslokale'],
    ['56.30.4', 'Ausschank von Getränken auf Jahrmärkten u. Ä.'],
    ['56.30.9', 'Ausschank von Getränken a. n. g.'],
    ['56.40.0', 'Vermittlungstätigkeiten für gastronomische Dienstleistungen'],
    ['58.11.0', 'Verlegen von Büchern'],
    ['58.12.0', 'Verlegen von Zeitungen'],
    ['58.13.0', 'Verlegen von Zeitschriften'],
    ['58.19.0', 'Sonstiges Verlagswesen, ohne Software'],
    ['58.21.0', 'Verlegen von Computerspielen'],
    ['58.29.0', 'Verlegen von sonstiger Software'],
    ['59.11.1', 'Herstellung von Vlogs'],
    ['59.11.2', 'Herstellung von sonstigen Videofilmen, von Filmen und Fernsehprogrammen'],
    ['59.12.0', 'Nachbearbeitung und sonstige Filmtechnik'],
    ['59.13.0', 'Filmverleih und -vertrieb, nicht an private Haushalte'],
    ['59.14.0', 'Kinos'],
    ['59.20.1', 'Musikverlage'],
    ['59.20.2', 'Herstellung von Tonaufnahmen (Tonstudios)'],
    ['59.20.3', 'Veröffentlichung von Musikaufnahmen (Labels)'],
    ['60.10.0', 'Hörfunkveranstalter und Verbreitung von Audioinhalten'],
    ['60.20.0', 'Fernsehveranstalter und Verbreitung von Videoinhalten'],
    ['60.31.0', 'Nachrichtenagenturen'],
    ['60.39.1', 'Online-Bereitstellung von Software'],
    ['60.39.2', 'Betrieb von Content-Sharing-Websites'],
    ['60.39.3', 'Verbreitung von Medieninhalten über Blogs'],
    ['60.39.9', 'Sonstige Verbreitung von Medieninhalten a. n. g.'],
    ['61.10.1', 'Leitungsgebundene Telekommunikation'],
    ['61.10.2', 'Drahtlose Telekommunikation und Satellitentelekommunikation'],
    ['61.20.0', 'Wiederverkaufs- und Vermittlungstätigkeiten für die Telekommunikation'],
    ['61.90.1', 'Internetserviceprovider'],
    ['61.90.2', 'Online-Kommunikationsdienste'],
    ['61.90.9', 'Sonstige Telekommunikation a. n. g.'],
    ['62.10.1', 'Entwicklung und Programmierung von Internetpräsentationen'],
    ['62.10.2', 'Entwicklung und Programmierung von Computerspielen'],
    ['62.10.3', 'Entwicklung und Programmierung von Anwendungssoftware'],
    ['62.10.4', 'Entwicklung und Programmierung von künstlicher Intelligenz und maschinellem Lernen'],
    ['62.10.9', 'Programmierungstätigkeiten a. n. g.'],
    ['62.20.1', 'Erbringung von Beratungsleistungen auf dem Gebiet der Informationstechnologie'],
    ['62.20.2', 'Betrieb von Datenverarbeitungseinrichtungen für Dritte'],
    ['62.90.0', 'Erbringung von sonstigen Dienstleistungen der Informationstechnologie'],
    ['63.10.1', 'Bereitstellung von Datenverarbeitungsdiensten'],
    ['63.10.2', 'Bereitstellung von IT-Infrastruktur, einschließlich Cloud-Infrastruktur'],
    ['63.10.9', 'Datenverarbeitung, Hosting und damit verbundene Tätigkeiten a. n. g.'],
    ['63.91.0', 'Web-Suchportale'],
    ['63.92.0', 'Erbringung von sonstigen Informationsdienstleistungen'],
    ['64.11.0', 'Zentralbanken'],
    ['64.19.1', 'Kreditbanken einschließlich Zweigstellen ausländischer Banken'],
    ['64.19.2', 'Kreditinstitute des Sparkassensektors'],
    ['64.19.3', 'Kreditinstitute des Genossenschaftssektors'],
    ['64.19.4', 'Realkreditinstitute'],
    ['64.19.5', 'Kreditinstitute mit Sonderaufgaben'],
    ['64.19.6', 'Bausparkassen'],
    ['64.21.0', 'Beteiligungsgesellschaften'],
    ['64.22.0', 'Finanzierungs-Conduits'],
    ['64.31.0', 'Investmentfonds'],
    ['64.32.0', 'Treuhandfonds, Nachlass- und Treuhandkonten'],
    ['64.91.0', 'Institutionen für Finanzierungsleasing'],
    ['64.92.1', 'Institute für Factoring-Geschäfte'],
    ['64.92.2', 'Leihhäuser'],
    ['64.92.3', 'Sonstige Spezialkreditinstitute'],
    ['64.99.1', 'Wagniskapital-Beteiligungsgesellschaften'],
    ['64.99.2', 'Verbriefungszweckgesellschaften a. n. g.'],
    ['64.99.9', 'Alle anderen Finanzdienstleistungen a. n. g.'],
    ['65.11.0', 'Lebensversicherung'],
    ['65.12.1', 'Krankenversicherungen'],
    ['65.12.2', 'Schaden- und Unfallversicherungen'],
    ['65.20.0', 'Rückversicherungen'],
    ['65.30.0', 'Pensionskassen und Pensionsfonds'],
    ['66.11.0', 'Effekten- und Warenbörsen'],
    ['66.12.0', 'Effekten- und Warenterminhandel'],
    ['66.19.1', 'Verarbeitung von Zahlungs- und anderen Finanztransaktionen'],
    ['66.19.2', 'Vermittlung von Krediten'],
    ['66.19.9', 'Sonstige mit Finanzdienstleistungen verbundene Tätigkeiten a. n. g.'],
    ['66.21.0', 'Risiko- und Schadensbewertung'],
    ['66.22.1', 'Tätigkeiten von Versicherungsmaklerinnen und -maklern'],
    ['66.22.2', 'Tätigkeiten von Versicherungsvertreterinnen und -vertretern'],
    [
        '66.29.0',
        'Mit Versicherungsdienstleistungen und Pensionskassen verbundene Tätigkeiten a. n. g.',
    ],
    ['66.30.0', 'Fondsmanagement'],
    ['68.11.1', 'Kauf und Verkauf von eigenen Wohngrundstücken, Wohngebäuden und Wohnungen'],
    ['68.11.2', 'Kauf und Verkauf von eigenen Gewerbegrundstücken und Nichtwohngebäuden'],
    ['68.12.1', 'Erschließung von unbebauten Grundstücken'],
    ['68.12.2', 'Bauträger für Wohngebäude'],
    ['68.12.3', 'Bauträger für andere Gebäude und Bauwerke'],
    [
        '68.20.1',
        'Vermietung, Verpachtung von eigenen oder geleasten Wohngrundstücken, Wohngebäuden und Wohnungen',
    ],
    [
        '68.20.2',
        'Vermietung, Verpachtung von eigenen oder geleasten Gewerbegrundstücken und Nichtwohngebäuden',
    ],
    ['68.31.1', 'Vermittlung von Wohngrundstücken, Wohngebäuden und Wohnungen für Dritte'],
    ['68.31.2', 'Vermittlung von Gewerbegrundstücken und Nichtwohngebäuden für Dritte'],
    ['68.32.1', 'Verwaltung von Wohngrundstücken, Wohngebäuden und Wohnungen für Dritte'],
    ['68.32.2', 'Verwaltung von Gewerbegrundstücken und Nichtwohngebäuden für Dritte'],
    ['69.10.1', 'Rechtsanwaltskanzleien und Notariate'],
    ['69.10.2', 'Patentanwaltskanzleien'],
    ['69.10.3', 'Erbringung sonstiger juristischer Dienstleistungen'],
    [
        '69.20.1',
        'Praxen von Wirtschaftsprüferinnen und -prüfern, vereidigten Buchprüferinnen und -prüfern, Wirtschaftsprüfungsgesellschaften und Buchprüfungsgesellschaften',
    ],
    [
        '69.20.2',
        'Praxen von Steuerberaterinnen und -beratern, Steuerbevollmächtigten sowie steuerberatende Berufsausübungsgesellschaften',
    ],
    ['69.20.3', 'Buchführung ohne Datenverarbeitungsdienste'],
    [
        '70.10.1',
        'Managementtätigkeiten von Holdinggesellschaften mit überwiegend finanziellem Anteilsbesitz',
    ],
    ['70.10.2', 'Managementtätigkeiten von Holdinggesellschaften mit aktivem Versicherungsgeschäft'],
    ['70.10.3', 'Managementtätigkeiten von sonstigen Holdinggesellschaften'],
    ['70.10.4', 'Sonstige Verwaltung und Führung von Unternehmen und Betrieben'],
    ['70.20.0', 'Unternehmensberatung'],
    ['71.11.1', 'Architekturbüros für Hochbau'],
    ['71.11.2', 'Büros für Innenarchitektur'],
    ['71.11.3', 'Architekturbüros für Orts-, Regional- und Landesplanung'],
    ['71.11.4', 'Architekturbüros für Garten- und Landschaftsgestaltung'],
    [
        '71.12.1',
        'Ingenieurbüros für bautechnische Gesamtplanung von Ingenieurbauwerken und Verkehrsanlagen',
    ],
    ['71.12.2', 'Ingenieurbüros für Tragwerksplanung'],
    ['71.12.3', 'Ingenieurbüros für Fachplanung von technischer Gebäudeausrüstung'],
    ['71.12.4', 'Ingenieurbüros für Fachplanung von sonstigen technischen Anlagen'],
    ['71.12.5', 'Vermessungsbüros'],
    ['71.12.6', 'Sonstige Ingenieurbüros'],
    ['71.20.0', 'Technische, physikalische und chemische Untersuchung'],
    ['72.10.1', 'Forschung und Entwicklung im Bereich Biotechnologie'],
    [
        '72.10.2',
        'Sonstige Forschung und Entwicklung im Bereich Natur-, Ingenieur-, Agrarwissenschaften und Medizin',
    ],
    [
        '72.20.0',
        'Forschung und Entwicklung im Bereich Rechts-, Wirtschafts- und Sozialwissenschaften sowie im Bereich Sprach-, Kultur- und Kunstwissenschaften',
    ],
    ['73.11.0', 'Tätigkeiten von Werbeagenturen'],
    ['73.12.0', 'Vermarktung und Vermittlung von Werbezeiten und Werbeflächen'],
    ['73.20.0', 'Markt- und Meinungsforschung'],
    ['73.30.0', 'Public-Relations-Beratung'],
    ['74.11.1', 'Industrie- und Produktdesign'],
    ['74.11.2', 'Modedesign'],
    ['74.12.0', 'Grafik- und Kommunikationsdesign'],
    ['74.13.0', 'Innenraumdesign und Raumgestaltung'],
    ['74.14.0', 'Sonstige spezialisierte Designtätigkeiten'],
    ['74.20.1', 'Fotografie'],
    [
        '74.20.2',
        'Bildentwicklung, -bearbeitung und Erbringung sonstiger fotografischer Dienstleistungen',
    ],
    ['74.30.1', 'Übersetzen'],
    ['74.30.2', 'Dolmetschen'],
    [
        '74.91.1',
        'Verwertungsgesellschaften zur Wahrnehmung von Urheberrechten und verwandten Schutzrechten',
    ],
    ['74.91.2', 'Erbringung sonstiger Vermittlungs- und Vermarktungsdienstleistungen für Patente'],
    ['74.99.1', 'Künstler- und Modelagenturen'],
    [
        '74.99.9',
        'Alle anderen Tätigkeiten typischerweise freiberuflicher, wissenschaftlicher oder technischer Art a. n. g. (ohne Künstler- und Modelagenturen)',
    ],
    ['75.00.1', 'Tierärztliche Praxen'],
    ['75.00.9', 'Veterinärwesen a. n. g.'],
    [
        '77.11.1',
        'Vermietung von Kraftwagen mit einem Gesamtgewicht von 3,5 t oder weniger mittels Carsharing',
    ],
    ['77.11.2', 'Sonstige Vermietung von Kraftwagen mit einem Gesamtgewicht von 3,5 t oder weniger'],
    ['77.12.0', 'Vermietung von Kraftwagen mit einem Gesamtgewicht von mehr als 3,5 t'],
    ['77.21.0', 'Vermietung von Sport- und Freizeitgeräten'],
    ['77.22.0', 'Vermietung von sonstigen Gebrauchsgütern'],
    ['77.31.0', 'Vermietung von landwirtschaftlichen Maschinen und Geräten'],
    ['77.32.0', 'Vermietung von Baumaschinen und -geräten'],
    ['77.33.0', 'Vermietung von Büromaschinen, Datenverarbeitungsgeräten und -einrichtungen'],
    ['77.34.0', 'Vermietung von Wasserfahrzeugen'],
    ['77.35.0', 'Vermietung von Luftfahrzeugen'],
    ['77.39.1', 'Vermietung von Schienenfahrzeugen'],
    ['77.39.9', 'Vermietung von sonstigen Maschinen, Geräten und beweglichen Sachen a. n. g.'],
    ['77.40.0', 'Leasing von nichtfinanziellen immateriellen Vermögensgütern, ohne Copyrights'],
    [
        '77.51.0',
        'Vermittlungstätigkeiten für die Vermietung und das Leasing von Autos, Wohnmobilen und Anhängern',
    ],
    [
        '77.52.0',
        'Vermittlungstätigkeiten für die Vermietung und das Leasing von sonstigen beweglichen Sachen und nichtfinanziellen immateriellen Vermögensgütern',
    ],
    ['78.10.0', 'Vermittlung von Arbeitskräften'],
    ['78.20.1', 'Befristete Überlassung von Arbeitskräften'],
    ['78.20.2', 'Sonstige Überlassung von Arbeitskräften'],
    ['79.11.0', 'Reisebüros'],
    ['79.12.0', 'Reiseveranstalter'],
    ['79.90.1', 'Reiseleiter und Gästeführer'],
    ['79.90.9', 'Erbringung sonstiger reisebezogener Dienstleistungen a. n. g.'],
    ['80.01.1', 'Detekteien'],
    ['80.01.2', 'Geld- und Wertdienste'],
    ['80.01.3', 'Luftsicherheitsdienste'],
    ['80.01.4', 'Private Wach- und Sicherheitsdienste für Veranstaltungen'],
    ['80.01.5', 'Sonstige private Wach- und Sicherheitsdienste'],
    ['80.09.0', 'Sicherheitsdienste a. n. g.'],
    ['81.10.0', 'Hausmeisterdienste'],
    ['81.21.0', 'Allgemeine Gebäudereinigung'],
    ['81.22.1', 'Schornsteinreinigung'],
    ['81.22.2', 'Sonstige spezielle Reinigung von Gebäuden und Maschinen'],
    ['81.23.1', 'Reinigung von Verkehrsmitteln'],
    ['81.23.2', 'Desinfektion und Schädlingsbekämpfung'],
    ['81.23.9', 'Sonstige Reinigung a. n. g.'],
    ['81.30.1', 'Garten- und Landschaftsbau'],
    ['81.30.2', 'Erbringung von sonstigen gärtnerischen Dienstleistungen'],
    ['82.10.0', 'Sekretariats- und Schreibdienste, Copy-Shops'],
    ['82.20.0', 'Call Centers'],
    ['82.30.0', 'Messe-, Kongress- und Business-Event-Veranstalter'],
    [
        '82.40.1',
        'Erbringung von Reservierungsdienstleistungen für Theater-, Sport- und Unterhaltungsveranstaltungen',
    ],
    [
        '82.40.9',
        'Sonstige Vermittlungstätigkeiten für die Erbringung von wirtschaftlichen Dienstleistungen für Unternehmen und Privatpersonen a. n. g.',
    ],
    ['82.91.1', 'Inkassobüros'],
    ['82.91.2', 'Auskunfteien'],
    ['82.92.0', 'Abfüllen und Verpacken'],
    ['82.99.1', 'Erbringung von Fundraising-Dienstleistungen'],
    [
        '82.99.9',
        'Erbringung von allen anderen wirtschaftlichen Dienstleistungen für Unternehmen und Privatpersonen a. n. g.',
    ],
    ['84.11.0', 'Allgemeine öffentliche Verwaltung'],
    ['84.12.1', 'Öffentliche Verwaltung des Gesundheitswesens'],
    ['84.12.2', 'Öffentliche Verwaltung der Bildung'],
    ['84.12.3', 'Öffentliche Verwaltung der Kultur und des Sports'],
    ['84.12.4', 'Öffentliche Verwaltung des Sozialwesens'],
    ['84.12.5', 'Öffentliche Verwaltung des Umwelt- und Naturschutzes'],
    ['84.12.9', 'Öffentliche Verwaltung a. n. g.'],
    ['84.13.0', 'Wirtschaftsförderung, -ordnung und -aufsicht'],
    ['84.21.0', 'Auswärtige Angelegenheiten'],
    ['84.22.0', 'Verteidigung'],
    ['84.23.0', 'Rechtspflege'],
    ['84.24.0', 'Öffentliche Sicherheit und Ordnung'],
    ['84.25.0', 'Feuerwehren'],
    ['84.30.0', 'Sozialversicherung'],
    ['85.10.1', 'Kinderkrippen und Kindertagespflege für Kinder unter 3 Jahren'],
    ['85.10.2', 'Kindergärten'],
    ['85.10.3', 'Vorklassen, Schulkindergärten'],
    ['85.20.0', 'Grundschulen'],
    ['85.31.1', 'Allgemeinbildende Schulen des Sekundarbereichs I'],
    ['85.31.2', 'Allgemeinbildende weiterführende Schulen des Sekundarbereichs II'],
    ['85.32.0', 'Berufsbildende weiterführende Schulen'],
    ['85.33.1', 'Postsekundärer, nicht tertiärer Unterricht in Schulen des Gesundheitswesens'],
    ['85.33.2', 'Postsekundärer, nicht tertiärer Unterricht in Schulen des Sozialwesens'],
    ['85.33.3', 'Sonstiger postsekundärer, nicht tertiärer Unterricht'],
    ['85.40.1', 'Universitäten'],
    ['85.40.2', 'Fachhochschulen, Duale Hochschulen, Verwaltungsfachhochschulen'],
    ['85.40.3', 'Aufstiegsfortbildung, Schulen der beruflichen Fortbildung'],
    ['85.40.9', 'Einrichtungen des tertiären Bildungsbereichs a. n. g.'],
    ['85.51.0', 'Sport- und Freizeitunterricht'],
    ['85.52.0', 'Kulturunterricht'],
    ['85.53.1', 'Fahrschulen'],
    ['85.53.2', 'Sportboot- und Segelschulen'],
    ['85.53.3', 'Flugschulen'],
    ['85.59.1', 'Allgemeine und politische Erwachsenenbildung'],
    ['85.59.2', 'Berufliche Erwachsenenbildung'],
    ['85.59.9', 'Erbringung von allen anderen Unterrichtsdienstleistungen a. n. g.'],
    ['85.61.0', 'Vermittlungstätigkeiten für Erziehung und Unterricht'],
    ['85.69.0', 'Erbringung von Dienstleistungen für Erziehung und Unterricht a. n. g.'],
    ['86.10.1', 'Krankenhäuser (ohne Hochschulkliniken, Vorsorge- und Rehabilitationskliniken)'],
    ['86.10.2', 'Hochschulkliniken'],
    ['86.10.3', 'Vorsorge- und Rehabilitationskliniken'],
    ['86.21.0', 'Arztpraxen für Allgemeinmedizin'],
    ['86.22.0', 'Facharztpraxen'],
    ['86.23.0', 'Zahnarztpraxen'],
    ['86.91.1', 'Erbringung von Dienstleistungen der diagnostischen Bildgebung'],
    ['86.91.2', 'Erbringung von Dienstleistungen von medizinischen Laboratorien'],
    ['86.92.0', 'Rettungs- und Krankentransportdienste'],
    [
        '86.93.0',
        'Erbringung von Dienstleistungen von Psychotherapeutinnen und -therapeuten, klinischen und Gesundheitspsychologinnen und -psychologen, ohne ärztliche Therapien',
    ],
    ['86.94.1', 'Ambulante Pflegedienste'],
    ['86.94.2', 'Geburtshilfe und Hebammen'],
    ['86.95.1', 'Erbringung von physiotherapeutischen Dienstleistungen (ohne Ergotherapie)'],
    ['86.95.2', 'Erbringung von ergotherapeutischen Dienstleistungen'],
    ['86.96.0', 'Traditionelle, komplementäre und alternative medizinische Tätigkeiten'],
    [
        '86.97.0',
        'Vermittlungstätigkeiten für medizinische, zahnärztliche und andere Gesundheitstätigkeiten',
    ],
    ['86.99.0', 'Sonstiges Gesundheitswesen a. n. g.'],
    ['87.10.1', 'Stationäre Einrichtungen zur palliativen Pflege'],
    ['87.10.2', 'Sonstige vollstationäre Pflegeeinrichtungen'],
    ['87.10.3', 'Sonstige teilstationäre Pflegeeinrichtungen'],
    ['87.20.0', 'Stationäre Einrichtungen zur psychosozialen Betreuung, Suchtbekämpfung'],
    ['87.30.1', 'Seniorenwohnheime'],
    ['87.30.2', 'Wohnheime für Menschen mit Behinderung'],
    ['87.91.0', 'Vermittlungstätigkeiten für Heime und stationäre Betreuung'],
    ['87.99.1', 'Heime und Wohngruppen für Kinder und Jugendliche, stationäre Hilfen zur Erziehung'],
    ['87.99.9', 'Sonstige Heime a. n. g.'],
    ['88.10.1', 'Ambulante Betreuungsdienste für ältere Menschen'],
    ['88.10.2', 'Ambulante Betreuungsdienste für Menschen mit Behinderung'],
    ['88.10.3', 'Sonstige soziale Betreuung von älteren Menschen'],
    ['88.10.4', 'Sonstige soziale Betreuung von Menschen mit Behinderung'],
    ['88.91.1', 'Außerunterrichtliche Betreuung für Schulkinder (ohne Jugendarbeit)'],
    ['88.91.9', 'Tagesbetreuung von Kindern a. n. g.'],
    ['88.99.1', 'Jugendarbeit (auch Jugendsozialarbeit)'],
    ['88.99.2', 'Erziehungsberatung'],
    ['88.99.3', 'Sonstige soziale Beratungsdienste'],
    ['88.99.9', 'Sonstiges Sozialwesen a. n. g. (ohne Jugendarbeit und soziale Beratungsdienste)'],
    ['90.11.1', 'Musikkomposition und -bearbeitung'],
    ['90.11.2', 'Schriftstellerei'],
    ['90.11.3', 'Journalismus'],
    ['90.11.4', 'Sonstiges literarisches Schaffen'],
    ['90.12.0', 'Bildende Kunst'],
    ['90.13.0', 'Sonstige kunstschaffende Tätigkeiten'],
    ['90.20.1', 'Schauspiel'],
    ['90.20.2', 'Opern und Musicals'],
    ['90.20.3', 'Orchester, Chöre sowie sonstige Musikerinnen und Musiker'],
    ['90.20.4', 'Ballett'],
    ['90.20.5', 'Zirkus und Artistik'],
    ['90.20.6', 'Sonstige darstellende Kunst'],
    ['90.31.1', 'Spielstätten für Schauspiel und Musiktheater'],
    ['90.31.2', 'Varietés und Kleinkunstbühnen'],
    ['90.31.3', 'Live-Musikspielstätten, Musikclubs und ähnliche soziokulturelle Zentren'],
    [
        '90.31.9',
        'Betrieb von Einrichtungen für kunstschaffende Tätigkeiten und darstellende Künste a. n. g.',
    ],
    ['90.39.1', 'Konzertveranstalter'],
    ['90.39.2', 'Theater-, Wort- und Literaturveranstalter'],
    ['90.39.3', 'Sonstige Entertainmentveranstalter'],
    [
        '90.39.9',
        'Erbringung von sonstigen Dienstleistungen für kunstschaffende Tätigkeiten und darstellende Künste a. n. g.',
    ],
    ['91.11.0', 'Bibliotheken'],
    ['91.12.0', 'Archive'],
    ['91.21.0', 'Museen und Sammlungen'],
    ['91.22.0', 'Historische Stätten und Denkmäler'],
    ['91.30.1', 'Konservierung und Restaurierung von kulturellem Erbe'],
    ['91.30.2', 'Sonstige unterstützende Tätigkeiten für das kulturelle Erbe'],
    ['91.41.0', 'Botanische und zoologische Gärten'],
    ['91.42.0', 'Naturparks'],
    ['92.00.1', 'Spielhallen und Betrieb von Glücksspielautomaten'],
    ['92.00.2', 'Spielbanken und Spielklubs'],
    ['92.00.3', 'Online-Glücksspiele und -Wetten'],
    ['92.00.4', 'Sonstiges Spiel-, Wett- und Lotteriewesen'],
    ['93.11.0', 'Betrieb von Sportanlagen'],
    ['93.12.0', 'Sportvereine'],
    ['93.13.0', 'Fitnesszentren'],
    ['93.19.0', 'Erbringung von Dienstleistungen des Sports a. n. g.'],
    ['93.21.0', 'Vergnügungs- und Themenparks'],
    [
        '93.29.1',
        'Betrieb von Fahr-, Spiel- und Schaugeschäften durch reisende Schaustellerinnen und Schausteller',
    ],
    [
        '93.29.2',
        'Erbringung von sonstigen Dienstleistungen für Veranstaltungen nicht künstlerischer Art',
    ],
    [
        '93.29.9',
        'Erbringung von allen anderen Dienstleistungen der Unterhaltung und der Erholung a. n. g.',
    ],
    ['94.11.0', 'Wirtschafts- und Arbeitgeberverbände'],
    ['94.12.0', 'Berufsorganisationen'],
    ['94.20.0', 'Arbeitnehmervereinigungen'],
    ['94.91.0', 'Kirchliche und sonstige religiöse Vereinigungen'],
    ['94.92.0', 'Politische Parteien und Vereinigungen'],
    ['94.99.1', 'Organisationen der Bildung, Wissenschaft und Forschung'],
    ['94.99.2', 'Organisationen der Kultur'],
    ['94.99.3', 'Verbraucherorganisationen'],
    ['94.99.4', 'Jugendorganisationen'],
    ['94.99.9', 'Alle anderen Interessenvertretungen und Vereinigungen a. n. g.'],
    ['95.10.1', 'Reparatur und Instandhaltung von Datenverarbeitungsgeräten und peripheren Geräten'],
    ['95.10.2', 'Reparatur und Instandhaltung von Telekommunikationsgeräten'],
    ['95.21.0', 'Reparatur und Instandhaltung von Geräten der Unterhaltungselektronik'],
    ['95.22.0', 'Reparatur und Instandhaltung von elektrischen Haushaltsgeräten und Gartengeräten'],
    ['95.23.0', 'Reparatur und Instandhaltung von Schuhen und Lederwaren'],
    ['95.24.0', 'Reparatur und Instandhaltung von Möbeln und Einrichtungsgegenständen'],
    ['95.25.0', 'Reparatur und Instandhaltung von Uhren und Schmuck'],
    ['95.29.0', 'Reparatur und Instandhaltung von Gebrauchsgütern a. n. g.'],
    ['95.31.1', 'Lackieren von Kraftwagen'],
    ['95.31.2', 'Autowaschanlagen'],
    [
        '95.31.3',
        'Sonstige Instandhaltung und Reparatur von Kraftwagen mit einem zulässigen Gesamtgewicht von 3,5 t oder weniger',
    ],
    [
        '95.31.4',
        'Sonstige Instandhaltung und Reparatur von Kraftwagen mit einem zulässigen Gesamtgewicht von mehr als 3,5 t',
    ],
    ['95.32.0', 'Reparatur und Instandhaltung von Krafträdern'],
    [
        '95.40.0',
        'Vermittlungstätigkeiten für die Reparatur und Instandhaltung von Datenverarbeitungsgeräten und Gebrauchsgütern sowie von Kraftwagen und Krafträdern',
    ],
    ['96.10.1', 'Wäscherei und chemische Reinigung für gewerbliche Kunden'],
    ['96.10.2', 'Wäscherei und chemische Reinigung für Privatkunden'],
    ['96.21.0', 'Frisör- und Barbiersalons'],
    ['96.22.0', 'Kosmetiksalons und ähnliche Schönheitsbehandlungen'],
    ['96.23.0', 'Day Spas, Saunas, Dampfbäder'],
    ['96.30.1', 'Bestattungsinstitute'],
    ['96.30.2', 'Friedhöfe und Krematorien'],
    ['96.40.0', 'Vermittlungstätigkeiten für überwiegend persönliche Dienstleistungen'],
    ['96.91.0', 'Erbringung von haushaltsbezogenen Dienstleistungen'],
    ['96.99.1', 'Tätowier- und Piercingstudios'],
    ['96.99.2', 'Prostitution und Prostitutionsgewerbe'],
    ['96.99.3', 'Betreuungsdienste für Heimtiere'],
    ['96.99.9', 'Erbringung von allen anderen überwiegend persönlichen Dienstleistungen a. n. g.'],
    ['97.00.0', 'Private Haushalte mit Hauspersonal'],
    [
        '98.10.0',
        'Herstellung von Waren durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
    ],
    [
        '98.20.0',
        'Erbringungen von Dienstleistungen durch private Haushalte für den Eigenbedarf ohne ausgeprägten Schwerpunkt',
    ],
    ['99.00.0', 'Exterritoriale Organisationen und Körperschaften'],
];
export const NAF_REV_2_SUBCLASSES = [
    [
        '01.11Z',
        "Culture de céréales (à l'exception du riz), de légumineuses et de graines oléagineuses",
    ],
    ['01.12Z', 'Culture du riz'],
    ['01.13Z', 'Culture de légumes, de melons, de racines et de tubercules'],
    ['01.14Z', 'Culture de la canne à sucre'],
    ['01.15Z', 'Culture du tabac'],
    ['01.16Z', 'Culture de plantes à fibres'],
    ['01.19Z', 'Autres cultures non permanentes'],
    ['01.21Z', 'Culture de la vigne'],
    ['01.22Z', 'Culture de fruits tropicaux et subtropicaux'],
    ['01.23Z', "Culture d'agrumes"],
    ['01.24Z', 'Culture de fruits à pépins et à noyau'],
    ['01.25Z', "Culture d'autres fruits d'arbres ou d'arbustes et de fruits à coque"],
    ['01.26Z', 'Culture de fruits oléagineux'],
    ['01.27Z', 'Culture de plantes à boissons'],
    ['01.28Z', 'Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques'],
    ['01.29Z', 'Autres cultures permanentes'],
    ['01.30Z', 'Reproduction de plantes'],
    ['01.41Z', 'Élevage de vaches laitières'],
    ['01.42Z', "Élevage d'autres bovins et de buffles"],
    ['01.43Z', "Élevage de chevaux et d'autres équidés"],
    ['01.44Z', "Élevage de chameaux et d'autres camélidés"],
    ['01.45Z', "Élevage d'ovins et de caprins"],
    ['01.46Z', 'Élevage de porcins'],
    ['01.47Z', 'Élevage de volailles'],
    ['01.49Z', "Élevage d'autres animaux"],
    ['01.50Z', 'Culture et élevage associés'],
    ['01.61Z', 'Activités de soutien aux cultures'],
    ['01.62Z', 'Activités de soutien à la production animale'],
    ['01.63Z', 'Traitement primaire des récoltes'],
    ['01.64Z', 'Traitement des semences'],
    ['01.70Z', 'Chasse, piégeage et services annexes'],
    ['02.10Z', 'Sylviculture et autres activités forestières'],
    ['02.20Z', 'Exploitation forestière'],
    ['02.30Z', "Récolte de produits forestiers non ligneux poussant à l'état sauvage"],
    ['02.40Z', "Services de soutien à l'exploitation forestière"],
    ['03.11Z', 'Pêche en mer'],
    ['03.12Z', 'Pêche en eau douce'],
    ['03.21Z', 'Aquaculture en mer'],
    ['03.22Z', 'Aquaculture en eau douce'],
    ['05.10Z', 'Extraction de houille'],
    ['05.20Z', 'Extraction de lignite'],
    ['06.10Z', 'Extraction de pétrole brut'],
    ['06.20Z', 'Extraction de gaz naturel'],
    ['07.10Z', 'Extraction de minerais de fer'],
    ['07.21Z', "Extraction de minerais d'uranium et de thorium"],
    ['07.29Z', "Extraction d'autres minerais de métaux non ferreux"],
    [
        '08.11Z',
        "Extraction de pierres ornementales et de construction, de calcaire industriel, de gypse, de craie et d'ardoise",
    ],
    ['08.12Z', 'Exploitation de gravières et sablières, extraction d’argiles et de kaolin'],
    ['08.91Z', "Extraction des minéraux chimiques et d'engrais minéraux "],
    ['08.92Z', 'Extraction de tourbe'],
    ['08.93Z', 'Production de sel '],
    ['08.99Z', 'Autres activités extractives n.c.a.'],
    ['09.10Z', "Activités de soutien à l'extraction d'hydrocarbures"],
    ['09.90Z', 'Activités de soutien aux autres industries extractives '],
    ['10.11Z', 'Transformation et conservation de la viande de boucherie'],
    ['10.12Z', 'Transformation et conservation de la viande de volaille'],
    ['10.13A', 'Préparation industrielle de produits à base de viande'],
    ['10.13B', 'Charcuterie'],
    ['10.20Z', 'Transformation et conservation de poisson, de crustacés et de mollusques'],
    ['10.31Z', 'Transformation et conservation de pommes de terre'],
    ['10.32Z', 'Préparation de jus de fruits et légumes'],
    ['10.39A', 'Autre transformation et conservation de légumes'],
    ['10.39B', 'Transformation et conservation de fruits'],
    ['10.41A', "Fabrication d'huiles et graisses brutes"],
    ['10.41B', "Fabrication d'huiles et graisses raffinées"],
    ['10.42Z', 'Fabrication de margarine et graisses comestibles similaires'],
    ['10.51A', 'Fabrication de lait liquide et de produits frais'],
    ['10.51B', 'Fabrication de beurre'],
    ['10.51C', 'Fabrication de fromage'],
    ['10.51D', "Fabrication d'autres produits laitiers"],
    ['10.52Z', 'Fabrication de glaces et sorbets'],
    ['10.61A', 'Meunerie'],
    ['10.61B', 'Autres activités du travail des grains'],
    ['10.62Z', 'Fabrication de produits amylacés'],
    ['10.71A', 'Fabrication industrielle de pain et de pâtisserie fraîche'],
    ['10.71B', 'Cuisson de produits de boulangerie'],
    ['10.71C', 'Boulangerie et boulangerie-pâtisserie'],
    ['10.71D', 'Pâtisserie'],
    ['10.72Z', 'Fabrication de biscuits, biscottes et pâtisseries de conservation'],
    ['10.73Z', 'Fabrication de pâtes alimentaires'],
    ['10.81Z', 'Fabrication de sucre'],
    ['10.82Z', 'Fabrication de cacao, chocolat et de produits de confiserie'],
    ['10.83Z', 'Transformation du thé et du café'],
    ['10.84Z', 'Fabrication de condiments et assaisonnements'],
    ['10.85Z', 'Fabrication de plats préparés'],
    ['10.86Z', "Fabrication d'aliments homogénéisés et diététiques"],
    ['10.89Z', "Fabrication d'autres produits alimentaires n.c.a."],
    ['10.91Z', "Fabrication d'aliments pour animaux de ferme"],
    ['10.92Z', "Fabrication d'aliments pour animaux de compagnie"],
    ['11.01Z', 'Production de boissons alcooliques distillées'],
    ['11.02A', 'Fabrication de vins effervescents'],
    ['11.02B', 'Vinification'],
    ['11.03Z', 'Fabrication de cidre et de vins de fruits '],
    ['11.04Z', "Production d'autres boissons fermentées non distillées"],
    ['11.05Z', 'Fabrication de bière'],
    ['11.06Z', 'Fabrication de malt'],
    ['11.07A', 'Industrie des eaux de table'],
    ['11.07B', 'Production de boissons rafraîchissantes'],
    ['12.00Z', 'Fabrication de produits à base de tabac'],
    ['13.10Z', 'Préparation de fibres textiles et filature'],
    ['13.20Z', 'Tissage'],
    ['13.30Z', 'Ennoblissement textile'],
    ['13.91Z', "Fabrication d'étoffes à mailles"],
    ['13.92Z', "Fabrication d'articles textiles, sauf habillement"],
    ['13.93Z', 'Fabrication de tapis et moquettes'],
    ['13.94Z', 'Fabrication de ficelles, cordes et filets'],
    ['13.95Z', 'Fabrication de non-tissés, sauf habillement'],
    ['13.96Z', "Fabrication d'autres textiles techniques et industriels"],
    ['13.99Z', "Fabrication d'autres textiles n.c.a."],
    ['14.11Z', 'Fabrication de vêtements en cuir'],
    ['14.12Z', 'Fabrication de vêtements de travail'],
    ['14.13Z', 'Fabrication de vêtements de dessus'],
    ['14.14Z', 'Fabrication de vêtements de dessous'],
    ['14.19Z', "Fabrication d'autres vêtements et accessoires"],
    ['14.20Z', "Fabrication d'articles en fourrure"],
    ['14.31Z', "Fabrication d'articles chaussants à mailles"],
    ['14.39Z', "Fabrication d'autres articles à mailles"],
    ['15.11Z', 'Apprêt et tannage des cuirs ; préparation et teinture des fourrures'],
    ['15.12Z', "Fabrication d'articles de voyage, de maroquinerie et de sellerie"],
    ['15.20Z', 'Fabrication de chaussures'],
    ['16.10A', 'Sciage et rabotage du bois, hors imprégnation'],
    ['16.10B', 'Imprégnation du bois'],
    ['16.21Z', 'Fabrication de placage et de panneaux de bois'],
    ['16.22Z', 'Fabrication de parquets assemblés'],
    ['16.23Z', "Fabrication de charpentes et d'autres menuiseries"],
    ['16.24Z', "Fabrication d'emballages en bois"],
    [
        '16.29Z',
        "Fabrication d'objets divers en bois ; fabrication d'objets en liège, vannerie et sparterie",
    ],
    ['17.11Z', 'Fabrication de pâte à papier'],
    ['17.12Z', 'Fabrication de papier et de carton'],
    ['17.21A', 'Fabrication de carton ondulé'],
    ['17.21B', 'Fabrication de cartonnages '],
    ['17.21C', "Fabrication d'emballages en papier"],
    ['17.22Z', "Fabrication d'articles en papier à usage sanitaire ou domestique"],
    ['17.23Z', "Fabrication d'articles de papeterie"],
    ['17.24Z', 'Fabrication de papiers peints'],
    ['17.29Z', "Fabrication d'autres articles en papier ou en carton"],
    ['18.11Z', 'Imprimerie de journaux'],
    ['18.12Z', 'Autre imprimerie (labeur)'],
    ['18.13Z', 'Activités de pré-presse '],
    ['18.14Z', 'Reliure et activités connexes'],
    ['18.20Z', "Reproduction d'enregistrements"],
    ['19.10Z', 'Cokéfaction'],
    ['19.20Z', 'Raffinage du pétrole'],
    ['20.11Z', 'Fabrication de gaz industriels'],
    ['20.12Z', 'Fabrication de colorants et de pigments'],
    ['20.13A', 'Enrichissement et  retraitement de matières nucléaires'],
    ['20.13B', "Fabrication d'autres produits chimiques inorganiques de base n.c.a."],
    ['20.14Z', "Fabrication d'autres produits chimiques organiques de base"],
    ['20.15Z', "Fabrication de produits azotés et d'engrais"],
    ['20.16Z', 'Fabrication de matières plastiques de base'],
    ['20.17Z', 'Fabrication de caoutchouc synthétique'],
    ['20.20Z', 'Fabrication de pesticides et d’autres produits agrochimiques'],
    ['20.30Z', 'Fabrication de peintures, vernis, encres et mastics'],
    ['20.41Z', "Fabrication de savons, détergents et produits d'entretien"],
    ['20.42Z', 'Fabrication de parfums et de produits pour la toilette'],
    ['20.51Z', 'Fabrication de produits explosifs'],
    ['20.52Z', 'Fabrication de colles'],
    ['20.53Z', "Fabrication d'huiles essentielles"],
    ['20.59Z', "Fabrication d'autres produits chimiques n.c.a."],
    ['20.60Z', 'Fabrication de fibres artificielles ou synthétiques'],
    ['21.10Z', 'Fabrication de produits pharmaceutiques de base'],
    ['21.20Z', 'Fabrication de préparations pharmaceutiques'],
    ['22.11Z', 'Fabrication et rechapage de pneumatiques'],
    ['22.19Z', "Fabrication d'autres articles en caoutchouc"],
    ['22.21Z', 'Fabrication de plaques, feuilles, tubes et profilés en matières plastiques'],
    ['22.22Z', "Fabrication d'emballages en matières plastiques"],
    ['22.23Z', "Fabrication d'éléments en matières plastiques pour la construction"],
    ['22.29A', 'Fabrication de pièces techniques à base de matières plastiques'],
    ['22.29B', 'Fabrication de produits de consommation courante en matières plastiques'],
    ['23.11Z', 'Fabrication de verre plat'],
    ['23.12Z', 'Façonnage et transformation du verre plat'],
    ['23.13Z', 'Fabrication de verre creux'],
    ['23.14Z', 'Fabrication de fibres de verre'],
    ['23.19Z', "Fabrication et façonnage d'autres articles en verre, y compris verre technique"],
    ['23.20Z', 'Fabrication de produits réfractaires'],
    ['23.31Z', 'Fabrication de carreaux en céramique'],
    ['23.32Z', 'Fabrication de briques, tuiles et produits de construction, en terre cuite'],
    ['23.41Z', "Fabrication d'articles céramiques à usage domestique ou ornemental"],
    ['23.42Z', "Fabrication d'appareils sanitaires en céramique"],
    ['23.43Z', "Fabrication d'isolateurs et pièces isolantes en céramique"],
    ['23.44Z', "Fabrication d'autres produits céramiques à usage technique"],
    ['23.49Z', "Fabrication d'autres produits céramiques"],
    ['23.51Z', 'Fabrication de ciment'],
    ['23.52Z', 'Fabrication de chaux et plâtre'],
    ['23.61Z', "Fabrication d'éléments en béton pour la construction"],
    ['23.62Z', "Fabrication d'éléments en plâtre pour la construction"],
    ['23.63Z', "Fabrication de béton prêt à l'emploi"],
    ['23.64Z', 'Fabrication de mortiers et bétons secs'],
    ['23.65Z', "Fabrication d'ouvrages en fibre-ciment"],
    ['23.69Z', "Fabrication d'autres ouvrages en béton, en ciment ou en plâtre"],
    ['23.70Z', 'Taille, façonnage et finissage de pierres'],
    ['23.91Z', 'Fabrication de produits abrasifs'],
    ['23.99Z', "Fabrication d'autres produits minéraux non métalliques n.c.a."],
    ['24.10Z', 'Sidérurgie'],
    [
        '24.20Z',
        'Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier ',
    ],
    ['24.31Z', 'Étirage à froid de barres'],
    ['24.32Z', 'Laminage à froid de feuillards'],
    ['24.33Z', 'Profilage à froid par formage ou pliage'],
    ['24.34Z', 'Tréfilage à froid'],
    ['24.41Z', 'Production de métaux précieux'],
    ['24.42Z', "Métallurgie de l'aluminium"],
    ['24.43Z', "Métallurgie du plomb, du zinc ou de l'étain"],
    ['24.44Z', 'Métallurgie du cuivre'],
    ['24.45Z', 'Métallurgie des autres métaux non ferreux'],
    ['24.46Z', 'Élaboration et transformation de matières nucléaires'],
    ['24.51Z', 'Fonderie de fonte'],
    ['24.52Z', "Fonderie d'acier"],
    ['24.53Z', 'Fonderie de métaux légers'],
    ['24.54Z', "Fonderie d'autres métaux non ferreux"],
    ['25.11Z', 'Fabrication de structures métalliques et de parties de structures'],
    ['25.12Z', 'Fabrication de portes et fenêtres en métal'],
    ['25.21Z', 'Fabrication de radiateurs et de chaudières pour le chauffage central'],
    ['25.29Z', "Fabrication d'autres réservoirs, citernes et conteneurs métalliques"],
    [
        '25.30Z',
        "Fabrication de générateurs de vapeur, à l'exception des chaudières pour le chauffage central",
    ],
    ['25.40Z', "Fabrication d'armes et de munitions"],
    ['25.50A', 'Forge, estampage, matriçage ; métallurgie des poudres'],
    ['25.50B', 'Découpage, emboutissage'],
    ['25.61Z', 'Traitement et revêtement des métaux'],
    ['25.62A', 'Décolletage'],
    ['25.62B', 'Mécanique industrielle'],
    ['25.71Z', 'Fabrication de coutellerie'],
    ['25.72Z', 'Fabrication de serrures et de ferrures'],
    ['25.73A', 'Fabrication de moules et modèles'],
    ['25.73B', "Fabrication d'autres outillages"],
    ['25.91Z', 'Fabrication de fûts et emballages métalliques similaires'],
    ['25.92Z', "Fabrication d'emballages métalliques légers"],
    ['25.93Z', "Fabrication d'articles en fils métalliques, de chaînes et de ressorts"],
    ['25.94Z', 'Fabrication de vis et de boulons'],
    ['25.99A', "Fabrication d'articles métalliques ménagers"],
    ['25.99B', "Fabrication d'autres articles métalliques"],
    ['26.11Z', 'Fabrication de composants électroniques'],
    ['26.12Z', 'Fabrication de cartes électroniques assemblées'],
    ['26.20Z', "Fabrication d'ordinateurs et d'équipements périphériques"],
    ['26.30Z', "Fabrication d'équipements de communication "],
    ['26.40Z', 'Fabrication de produits électroniques grand public'],
    ['26.51A', "Fabrication d'équipements d'aide à la navigation"],
    ['26.51B', "Fabrication d'instrumentation scientifique et technique"],
    ['26.52Z', 'Horlogerie'],
    [
        '26.60Z',
        "Fabrication d'équipements d'irradiation médicale, d'équipements électromédicaux et électrothérapeutiques ",
    ],
    ['26.70Z', 'Fabrication de matériels optique et photographique'],
    ['26.80Z', 'Fabrication de supports magnétiques et optiques'],
    ['27.11Z', 'Fabrication de moteurs, génératrices et transformateurs électriques'],
    ['27.12Z', 'Fabrication de matériel de distribution et de commande électrique'],
    ['27.20Z', "Fabrication de piles et d'accumulateurs électriques"],
    ['27.31Z', 'Fabrication de câbles de fibres optiques'],
    ['27.32Z', "Fabrication d'autres fils et câbles électroniques ou électriques"],
    ['27.33Z', "Fabrication de matériel d'installation électrique"],
    ['27.40Z', "Fabrication d'appareils d'éclairage électrique"],
    ['27.51Z', "Fabrication d'appareils électroménagers"],
    ['27.52Z', "Fabrication d'appareils ménagers non électriques"],
    ['27.90Z', "Fabrication d'autres matériels électriques"],
    [
        '28.11Z',
        "Fabrication de moteurs et turbines, à l'exception des moteurs d’avions et de véhicules",
    ],
    ['28.12Z', "Fabrication d'équipements hydrauliques et pneumatiques"],
    ['28.13Z', "Fabrication d'autres pompes et compresseurs"],
    ['28.14Z', "Fabrication d'autres articles de robinetterie"],
    ['28.15Z', "Fabrication d'engrenages et d'organes mécaniques de transmission"],
    ['28.21Z', 'Fabrication de fours et brûleurs'],
    ['28.22Z', 'Fabrication de matériel de levage et de manutention'],
    [
        '28.23Z',
        "Fabrication de machines et d'équipements de bureau (à l'exception des ordinateurs et équipements périphériques)",
    ],
    ['28.24Z', "Fabrication d'outillage portatif à moteur incorporé"],
    ['28.25Z', "Fabrication d'équipements aérauliques et frigorifiques industriels"],
    ['28.29A', "Fabrication d'équipements d'emballage, de conditionnement et de pesage "],
    ['28.29B', "Fabrication d'autres machines d'usage général"],
    ['28.30Z', 'Fabrication de machines agricoles et forestières'],
    ['28.41Z', 'Fabrication de machines-outils pour le travail des métaux'],
    ['28.49Z', "Fabrication d'autres machines-outils "],
    ['28.91Z', 'Fabrication de machines pour la métallurgie'],
    ['28.92Z', "Fabrication de machines pour l'extraction ou la construction"],
    ['28.93Z', "Fabrication de machines pour l'industrie agro-alimentaire"],
    ['28.94Z', 'Fabrication de machines pour les industries textiles'],
    ['28.95Z', 'Fabrication de machines pour les industries du papier et du carton'],
    ['28.96Z', 'Fabrication de machines pour le travail du caoutchouc ou des plastiques'],
    ['28.99A', "Fabrication de machines d'imprimerie"],
    ['28.99B', "Fabrication d'autres machines spécialisées"],
    ['29.10Z', 'Construction de véhicules automobiles'],
    ['29.20Z', 'Fabrication de carrosseries et remorques'],
    ['29.31Z', "Fabrication d'équipements électriques et électroniques automobiles"],
    ['29.32Z', "Fabrication d'autres équipements automobiles"],
    ['30.11Z', 'Construction de navires et de structures flottantes'],
    ['30.12Z', 'Construction de bateaux de plaisance'],
    ['30.20Z', "Construction de locomotives et d'autre matériel ferroviaire roulant "],
    ['30.30Z', 'Construction aéronautique et spatiale '],
    ['30.40Z', 'Construction de véhicules militaires de combat '],
    ['30.91Z', 'Fabrication de motocycles'],
    ['30.92Z', 'Fabrication de bicyclettes et de véhicules pour invalides'],
    ['30.99Z', 'Fabrication d’autres équipements de transport n.c.a.'],
    ['31.01Z', 'Fabrication de meubles de bureau et de magasin'],
    ['31.02Z', 'Fabrication de meubles de cuisine '],
    ['31.03Z', 'Fabrication de matelas'],
    ['31.09A', "Fabrication de sièges d'ameublement d'intérieur"],
    ['31.09B', 'Fabrication d’autres meubles et industries connexes de l’ameublement'],
    ['32.11Z', 'Frappe de monnaie'],
    ['32.12Z', 'Fabrication d’articles de joaillerie et bijouterie'],
    ['32.13Z', 'Fabrication d’articles de bijouterie fantaisie et articles similaires'],
    ['32.20Z', "Fabrication d'instruments de musique"],
    ['32.30Z', "Fabrication d'articles de sport"],
    ['32.40Z', 'Fabrication de jeux et jouets'],
    ['32.50A', 'Fabrication de matériel médico-chirurgical et dentaire'],
    ['32.50B', 'Fabrication de lunettes'],
    ['32.91Z', 'Fabrication d’articles de brosserie'],
    ['32.99Z', 'Autres activités manufacturières n.c.a. '],
    ['33.11Z', "Réparation d'ouvrages en métaux"],
    ['33.12Z', 'Réparation de machines et équipements mécaniques'],
    ['33.13Z', 'Réparation de matériels électroniques et optiques'],
    ['33.14Z', "Réparation d'équipements électriques"],
    ['33.15Z', 'Réparation et maintenance navale'],
    ['33.16Z', "Réparation et maintenance d'aéronefs et d'engins spatiaux "],
    ['33.17Z', "Réparation et maintenance d'autres équipements de transport"],
    ['33.19Z', "Réparation d'autres équipements"],
    ['33.20A', 'Installation de structures métalliques, chaudronnées et de tuyauterie'],
    ['33.20B', 'Installation de machines et équipements mécaniques'],
    [
        '33.20C',
        "Conception d'ensemble et assemblage sur site industriel d'équipements de contrôle des processus industriels ",
    ],
    [
        '33.20D',
        "Installation d'équipements électriques, de matériels électroniques et optiques ou d'autres matériels",
    ],
    ['35.11Z', "Production d'électricité"],
    ['35.12Z', "Transport d'électricité"],
    ['35.13Z', "Distribution d'électricité"],
    ['35.14Z', "Commerce d'électricité"],
    ['35.21Z', 'Production de combustibles gazeux'],
    ['35.22Z', 'Distribution de combustibles gazeux par conduites'],
    ['35.23Z', 'Commerce de combustibles gazeux par conduites'],
    ['35.30Z', "Production et distribution de vapeur et d'air conditionné "],
    ['36.00Z', "Captage, traitement et distribution d'eau"],
    ['37.00Z', 'Collecte et traitement des eaux usées'],
    ['38.11Z', 'Collecte des déchets non dangereux'],
    ['38.12Z', 'Collecte des déchets dangereux'],
    ['38.21Z', 'Traitement et élimination des déchets non dangereux'],
    ['38.22Z', 'Traitement et élimination des déchets dangereux'],
    ['38.31Z', "Démantèlement d'épaves"],
    ['38.32Z', 'Récupération de déchets triés'],
    ['39.00Z', 'Dépollution et autres services de gestion des déchets'],
    ['41.10A', 'Promotion immobilière de logements'],
    ['41.10B', 'Promotion immobilière de bureaux'],
    ['41.10C', "Promotion immobilière d'autres bâtiments"],
    ['41.10D', 'Supports juridiques de programmes'],
    ['41.20A', 'Construction de maisons individuelles'],
    ['41.20B', "Construction d'autres bâtiments"],
    ['42.11Z', 'Construction de routes et autoroutes'],
    ['42.12Z', 'Construction de voies ferrées de surface et souterraines'],
    ['42.13A', "Construction d'ouvrages d'art"],
    ['42.13B', 'Construction et entretien de tunnels'],
    ['42.21Z', 'Construction de réseaux pour fluides'],
    ['42.22Z', 'Construction de réseaux électriques et de télécommunications'],
    ['42.91Z', "Construction d'ouvrages maritimes et fluviaux"],
    ['42.99Z', "Construction d'autres ouvrages de génie civil n.c.a."],
    ['43.11Z', 'Travaux de démolition'],
    ['43.12A', 'Travaux de terrassement courants et travaux préparatoires'],
    ['43.12B', 'Travaux de terrassement spécialisés ou de grande masse'],
    ['43.13Z', 'Forages et sondages'],
    ['43.21A', "Travaux d'installation électrique dans tous locaux"],
    ['43.21B', "Travaux d'installation électrique sur la voie publique"],
    ['43.22A', "Travaux d'installation d'eau et de gaz en tous locaux"],
    ['43.22B', "Travaux d'installation d'équipements thermiques et de climatisation"],
    ['43.29A', "Travaux d'isolation"],
    ['43.29B', "Autres travaux d'installation n.c.a."],
    ['43.31Z', 'Travaux de plâtrerie'],
    ['43.32A', 'Travaux de menuiserie bois et PVC'],
    ['43.32B', 'Travaux de menuiserie métallique et serrurerie'],
    ['43.32C', 'Agencement de lieux de vente'],
    ['43.33Z', 'Travaux de revêtement des sols et des murs'],
    ['43.34Z', 'Travaux de peinture et vitrerie'],
    ['43.39Z', 'Autres travaux de finition'],
    ['43.91A', 'Travaux de charpente'],
    ['43.91B', 'Travaux de couverture par éléments'],
    ['43.99A', "Travaux d'étanchéification"],
    ['43.99B', 'Travaux de montage de structures métalliques'],
    ['43.99C', 'Travaux de maçonnerie générale et gros œuvre de bâtiment'],
    ['43.99D', 'Autres travaux spécialisés de construction'],
    ['43.99E', 'Location avec opérateur de matériel de construction'],
    ['45.11Z', 'Commerce de voitures et de véhicules automobiles légers'],
    ['45.19Z', "Commerce d'autres véhicules automobiles"],
    ['45.20A', 'Entretien et réparation de véhicules automobiles légers'],
    ['45.20B', "Entretien et réparation d'autres véhicules automobiles"],
    ['45.31Z', "Commerce de gros d'équipements automobiles"],
    ['45.32Z', "Commerce de détail d'équipements automobiles"],
    ['45.40Z', 'Commerce et réparation de motocycles'],
    [
        '46.11Z',
        'Intermédiaires du commerce en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis',
    ],
    ['46.12A', "Centrales d'achat de carburant"],
    [
        '46.12B',
        'Autres intermédiaires du commerce en combustibles, métaux, minéraux et produits chimiques',
    ],
    ['46.13Z', 'Intermédiaires du commerce en bois et matériaux de construction'],
    ['46.14Z', 'Intermédiaires du commerce en machines, équipements industriels, navires et avions'],
    ['46.15Z', 'Intermédiaires du commerce en meubles, articles de ménage et quincaillerie'],
    [
        '46.16Z',
        'Intermédiaires du commerce en textiles, habillement, fourrures, chaussures et articles en cuir',
    ],
    ['46.17A', "Centrales d'achat alimentaires"],
    ['46.17B', 'Autres intermédiaires du commerce en denrées, boissons et tabac'],
    ['46.18Z', "Intermédiaires spécialisés dans le commerce d'autres produits spécifiques"],
    ['46.19A', "Centrales d'achat non alimentaires"],
    ['46.19B', 'Autres intermédiaires du commerce en produits divers'],
    [
        '46.21Z',
        "Commerce de gros (commerce interentreprises) de céréales, de tabac non manufacturé, de semences et d'aliments pour le bétail ",
    ],
    ['46.22Z', 'Commerce de gros (commerce interentreprises) de fleurs et plantes'],
    ['46.23Z', "Commerce de gros (commerce interentreprises) d'animaux vivants"],
    ['46.24Z', 'Commerce de gros (commerce interentreprises) de cuirs et peaux'],
    ['46.31Z', 'Commerce de gros (commerce interentreprises) de fruits et légumes'],
    ['46.32A', 'Commerce de gros (commerce interentreprises) de viandes de boucherie'],
    ['46.32B', 'Commerce de gros (commerce interentreprises) de produits à base de viande'],
    ['46.32C', 'Commerce de gros (commerce interentreprises) de volailles et gibier'],
    [
        '46.33Z',
        'Commerce de gros (commerce interentreprises) de produits laitiers, œufs, huiles et matières grasses comestibles',
    ],
    ['46.34Z', 'Commerce de gros (commerce interentreprises) de boissons'],
    ['46.35Z', 'Commerce de gros (commerce interentreprises) de produits à base de tabac'],
    ['46.36Z', 'Commerce de gros (commerce interentreprises) de sucre, chocolat et confiserie'],
    ['46.37Z', 'Commerce de gros (commerce interentreprises) de café, thé, cacao et épices'],
    ['46.38A', 'Commerce de gros (commerce interentreprises) de poissons, crustacés et mollusques'],
    ['46.38B', 'Commerce de gros (commerce interentreprises) alimentaire spécialisé divers'],
    ['46.39A', 'Commerce de gros (commerce interentreprises) de produits surgelés'],
    ['46.39B', 'Commerce de gros (commerce interentreprises) alimentaire non spécialisé'],
    ['46.41Z', 'Commerce de gros (commerce interentreprises) de textiles'],
    ['46.42Z', "Commerce de gros (commerce interentreprises) d'habillement et de chaussures"],
    ['46.43Z', "Commerce de gros (commerce interentreprises) d'appareils électroménagers"],
    [
        '46.44Z',
        "Commerce de gros (commerce interentreprises) de vaisselle, verrerie et produits d'entretien",
    ],
    ['46.45Z', 'Commerce de gros (commerce interentreprises) de parfumerie et de produits de beauté'],
    ['46.46Z', 'Commerce de gros (commerce interentreprises) de produits pharmaceutiques'],
    [
        '46.47Z',
        "Commerce de gros (commerce interentreprises) de meubles, de tapis et d'appareils d'éclairage ",
    ],
    [
        '46.48Z',
        "Commerce de gros (commerce interentreprises) d'articles d'horlogerie et de bijouterie",
    ],
    ['46.49Z', "Commerce de gros (commerce interentreprises) d'autres biens domestiques "],
    [
        '46.51Z',
        "Commerce de gros (commerce interentreprises) d'ordinateurs, d'équipements informatiques périphériques et de logiciels",
    ],
    [
        '46.52Z',
        "Commerce de gros (commerce interentreprises) de composants et d'équipements électroniques et de télécommunication",
    ],
    ['46.61Z', 'Commerce de gros (commerce interentreprises) de matériel agricole'],
    ['46.62Z', 'Commerce de gros (commerce interentreprises) de machines-outils'],
    [
        '46.63Z',
        "Commerce de gros (commerce interentreprises) de machines pour l'extraction, la construction et le génie civil ",
    ],
    [
        '46.64Z',
        "Commerce de gros (commerce interentreprises) de machines pour l'industrie textile et l'habillement",
    ],
    ['46.65Z', 'Commerce de gros (commerce interentreprises) de mobilier de bureau'],
    [
        '46.66Z',
        "Commerce de gros (commerce interentreprises) d'autres machines et équipements de bureau ",
    ],
    ['46.69A', 'Commerce de gros (commerce interentreprises) de matériel électrique'],
    [
        '46.69B',
        'Commerce de gros (commerce interentreprises) de fournitures et équipements industriels divers',
    ],
    [
        '46.69C',
        'Commerce de gros (commerce interentreprises) de fournitures et équipements divers pour le commerce et les services',
    ],
    ['46.71Z', 'Commerce de gros (commerce interentreprises) de combustibles et de produits annexes'],
    ['46.72Z', 'Commerce de gros (commerce interentreprises) de minerais et métaux'],
    [
        '46.73A',
        'Commerce de gros (commerce interentreprises) de bois et de matériaux de construction ',
    ],
    [
        '46.73B',
        "Commerce de gros (commerce interentreprises) d'appareils sanitaires et de produits de décoration",
    ],
    ['46.74A', 'Commerce de gros (commerce interentreprises) de quincaillerie'],
    [
        '46.74B',
        'Commerce de gros (commerce interentreprises) de fournitures pour la plomberie et le chauffage',
    ],
    ['46.75Z', 'Commerce de gros (commerce interentreprises) de produits chimiques'],
    ['46.76Z', "Commerce de gros (commerce interentreprises) d'autres produits intermédiaires"],
    ['46.77Z', 'Commerce de gros (commerce interentreprises) de déchets et débris'],
    ['46.90Z', 'Commerce de gros (commerce interentreprises) non spécialisé'],
    ['47.11A', 'Commerce de détail de produits surgelés'],
    ['47.11B', "Commerce d'alimentation générale"],
    ['47.11C', 'Supérettes'],
    ['47.11D', 'Supermarchés'],
    ['47.11E', 'Magasins multi-commerces'],
    ['47.11F', 'Hypermarchés'],
    ['47.19A', 'Grands magasins'],
    ['47.19B', 'Autres commerces de détail en magasin non spécialisé'],
    ['47.21Z', 'Commerce de détail de fruits et légumes en magasin spécialisé'],
    ['47.22Z', 'Commerce de détail de viandes et de produits à base de viande en magasin spécialisé'],
    ['47.23Z', 'Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé'],
    ['47.24Z', 'Commerce de détail de pain, pâtisserie et confiserie en magasin spécialisé'],
    ['47.25Z', 'Commerce de détail de boissons en magasin spécialisé'],
    ['47.26Z', 'Commerce de détail de produits à base de tabac en magasin spécialisé'],
    ['47.29Z', 'Autres commerces de détail alimentaires en magasin spécialisé '],
    ['47.30Z', 'Commerce de détail de carburants en magasin spécialisé'],
    [
        '47.41Z',
        "Commerce de détail d'ordinateurs, d'unités périphériques et de logiciels en magasin spécialisé",
    ],
    ['47.42Z', 'Commerce de détail de matériels de télécommunication en magasin spécialisé'],
    ['47.43Z', 'Commerce de détail de matériels audio et vidéo en magasin spécialisé'],
    ['47.51Z', 'Commerce de détail de textiles en magasin spécialisé'],
    [
        '47.52A',
        'Commerce de détail de quincaillerie, peintures et verres en petites surfaces (moins de 400 m2)',
    ],
    [
        '47.52B',
        'Commerce de détail de quincaillerie, peintures et verres en grandes surfaces (400 m2et plus)',
    ],
    [
        '47.53Z',
        'Commerce de détail de tapis, moquettes et revêtements de murs et de sols en magasin spécialisé',
    ],
    ['47.54Z', "Commerce de détail d'appareils électroménagers en magasin spécialisé"],
    ['47.59A', 'Commerce de détail de meubles'],
    ['47.59B', "Commerce de détail d'autres équipements du foyer"],
    ['47.61Z', 'Commerce de détail de livres en magasin spécialisé'],
    ['47.62Z', 'Commerce de détail de journaux et papeterie en magasin spécialisé'],
    ['47.63Z', "Commerce de détail d'enregistrements musicaux et vidéo en magasin spécialisé"],
    ['47.64Z', "Commerce de détail d'articles de sport en magasin spécialisé"],
    ['47.65Z', 'Commerce de détail de jeux et jouets en magasin spécialisé'],
    ['47.71Z', "Commerce de détail d'habillement en magasin spécialisé"],
    ['47.72A', 'Commerce de détail de la chaussure'],
    ['47.72B', "Commerce de détail de maroquinerie et d'articles de voyage"],
    ['47.73Z', 'Commerce de détail de produits pharmaceutiques en magasin spécialisé'],
    ['47.74Z', "Commerce de détail d'articles médicaux et orthopédiques en magasin spécialisé"],
    ['47.75Z', 'Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé'],
    [
        '47.76Z',
        'Commerce de détail de fleurs, plantes, graines, engrais, animaux de compagnie et aliments pour ces animaux en magasin spécialisé',
    ],
    ['47.77Z', "Commerce de détail d'articles d'horlogerie et de bijouterie en magasin spécialisé"],
    ['47.78A', "Commerces de détail d'optique"],
    ['47.78B', 'Commerces de détail de charbons et combustibles'],
    ['47.78C', 'Autres commerces de détail spécialisés divers'],
    ['47.79Z', "Commerce de détail de biens d'occasion en magasin"],
    ['47.81Z', 'Commerce de détail alimentaire sur éventaires et marchés'],
    [
        '47.82Z',
        "Commerce de détail de textiles, d'habillement et de chaussures sur éventaires et marchés",
    ],
    ['47.89Z', 'Autres commerces de détail sur éventaires et marchés'],
    ['47.91A', 'Vente à distance sur catalogue général'],
    ['47.91B', 'Vente à distance sur catalogue spécialisé'],
    ['47.99A', 'Vente à domicile'],
    [
        '47.99B',
        'Vente par automates et autres commerces de détail hors magasin, éventaires ou marchés n.c.a.',
    ],
    ['49.10Z', 'Transport ferroviaire interurbain de voyageurs'],
    ['49.20Z', 'Transports ferroviaires de fret '],
    ['49.31Z', 'Transports urbains et suburbains de voyageurs'],
    ['49.32Z', 'Transports de voyageurs par taxis'],
    ['49.39A', 'Transports routiers réguliers de voyageurs'],
    ['49.39B', 'Autres transports routiers de voyageurs '],
    ['49.39C', 'Téléphériques et remontées mécaniques'],
    ['49.41A', 'Transports routiers de fret interurbains'],
    ['49.41B', 'Transports routiers de fret de proximité'],
    ['49.41C', 'Location de camions avec chauffeur'],
    ['49.42Z', 'Services de déménagement'],
    ['49.50Z', 'Transports par conduites'],
    ['50.10Z', 'Transports maritimes et côtiers de passagers'],
    ['50.20Z', 'Transports maritimes et côtiers de fret'],
    ['50.30Z', 'Transports fluviaux de passagers'],
    ['50.40Z', 'Transports fluviaux de fret '],
    ['51.10Z', 'Transports aériens de passagers'],
    ['51.21Z', 'Transports aériens de fret'],
    ['51.22Z', 'Transports spatiaux'],
    ['52.10A', 'Entreposage et stockage frigorifique'],
    ['52.10B', 'Entreposage et stockage non frigorifique'],
    ['52.21Z', 'Services auxiliaires des transports terrestres'],
    ['52.22Z', 'Services auxiliaires des transports par eau'],
    ['52.23Z', 'Services auxiliaires des transports aériens'],
    ['52.24A', 'Manutention portuaire'],
    ['52.24B', 'Manutention non portuaire'],
    ['52.29A', 'Messagerie, fret express'],
    ['52.29B', 'Affrètement et organisation des transports '],
    ['53.10Z', "Activités de poste dans le cadre d'une obligation de service universel "],
    ['53.20Z', 'Autres activités de poste et de courrier'],
    ['55.10Z', 'Hôtels et hébergement similaire '],
    ['55.20Z', 'Hébergement touristique et autre hébergement de courte durée '],
    ['55.30Z', 'Terrains de camping et parcs pour caravanes ou véhicules de loisirs'],
    ['55.90Z', 'Autres hébergements '],
    ['56.10A', 'Restauration traditionnelle'],
    ['56.10B', 'Cafétérias et autres libres-services'],
    ['56.10C', 'Restauration de type rapide'],
    ['56.21Z', 'Services des traiteurs '],
    ['56.29A', 'Restauration collective sous contrat'],
    ['56.29B', 'Autres services de restauration n.c.a.'],
    ['56.30Z', 'Débits de boissons'],
    ['58.11Z', 'Édition de livres'],
    ['58.12Z', "Édition de répertoires et de fichiers d'adresses"],
    ['58.13Z', 'Édition de journaux'],
    ['58.14Z', 'Édition de revues et périodiques'],
    ['58.19Z', "Autres activités d'édition"],
    ['58.21Z', 'Édition de jeux électroniques'],
    ['58.29A', 'Édition de logiciels système et de réseau'],
    ['58.29B', 'Edition de logiciels outils de développement et de langages'],
    ['58.29C', 'Edition de logiciels applicatifs'],
    ['59.11A', 'Production de films et de programmes pour la télévision '],
    ['59.11B', 'Production de films institutionnels et publicitaires'],
    ['59.11C', 'Production de films pour le cinéma'],
    [
        '59.12Z',
        'Post-production de films cinématographiques, de vidéo et de programmes de télévision',
    ],
    ['59.13A', 'Distribution de films cinématographiques'],
    ['59.13B', 'Edition et distribution vidéo'],
    ['59.14Z', 'Projection de films cinématographiques'],
    ['59.20Z', 'Enregistrement sonore et édition musicale '],
    ['60.10Z', 'Édition et diffusion de programmes radio'],
    ['60.20A', 'Edition de chaînes généralistes'],
    ['60.20B', 'Edition de chaînes thématiques'],
    ['61.10Z', 'Télécommunications filaires'],
    ['61.20Z', 'Télécommunications sans fil '],
    ['61.30Z', 'Télécommunications par satellite'],
    ['61.90Z', 'Autres activités de télécommunication '],
    ['62.01Z', 'Programmation informatique'],
    ['62.02A', 'Conseil en systèmes et logiciels informatiques'],
    ['62.02B', 'Tierce maintenance de systèmes et d’applications informatiques'],
    ['62.03Z', "Gestion d'installations informatiques"],
    ['62.09Z', 'Autres activités informatiques'],
    ['63.11Z', 'Traitement de données, hébergement et activités connexes'],
    ['63.12Z', 'Portails Internet'],
    ['63.91Z', 'Activités des agences de presse'],
    ['63.99Z', "Autres services d'information n.c.a."],
    ['64.11Z', 'Activités de banque centrale'],
    ['64.19Z', 'Autres intermédiations monétaires'],
    ['64.20Z', 'Activités des sociétés holding'],
    ['64.30Z', 'Fonds de placement et entités financières similaires'],
    ['64.91Z', 'Crédit-bail '],
    ['64.92Z', 'Autre distribution de crédit'],
    [
        '64.99Z',
        'Autres activités des services financiers, hors assurance et caisses de retraite, n.c.a.',
    ],
    ['65.11Z', 'Assurance vie'],
    ['65.12Z', 'Autres assurances'],
    ['65.20Z', 'Réassurance'],
    ['65.30Z', 'Caisses de retraite'],
    ['66.11Z', 'Administration de marchés financiers'],
    ['66.12Z', 'Courtage de valeurs mobilières et de marchandises'],
    ['66.19A', 'Supports juridiques de gestion de patrimoine mobilier'],
    [
        '66.19B',
        'Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite, n.c.a.',
    ],
    ['66.21Z', 'Évaluation des risques et dommages'],
    ['66.22Z', "Activités des agents et courtiers d'assurances"],
    ['66.29Z', "Autres activités auxiliaires d'assurance et de caisses de retraite"],
    ['66.30Z', 'Gestion de fonds'],
    ['68.10Z', 'Activités des marchands de biens immobiliers'],
    ['68.20A', 'Location de logements'],
    ['68.20B', "Location de terrains et d'autres biens immobiliers"],
    ['68.31Z', 'Agences immobilières'],
    ['68.32A', "Administration d'immeubles et autres biens immobiliers"],
    ['68.32B', 'Supports juridiques de gestion de patrimoine immobilier'],
    ['69.10Z', 'Activités juridiques'],
    ['69.20Z', 'Activités comptables'],
    ['70.10Z', 'Activités des sièges sociaux'],
    ['70.21Z', 'Conseil en relations publiques et communication'],
    ['70.22Z', 'Conseil pour les affaires et autres conseils de gestion'],
    ['71.11Z', "Activités d'architecture "],
    ['71.12A', 'Activité des géomètres'],
    ['71.12B', 'Ingénierie, études techniques'],
    ['71.20A', 'Contrôle technique automobile'],
    ['71.20B', 'Analyses, essais et inspections techniques'],
    ['72.11Z', 'Recherche-développement en biotechnologie'],
    ['72.19Z', 'Recherche-développement en autres sciences physiques et naturelles'],
    ['72.20Z', 'Recherche-développement en sciences humaines et sociales'],
    ['73.11Z', 'Activités des agences de publicité'],
    ['73.12Z', 'Régie publicitaire de médias'],
    ['73.20Z', 'Études de marché et sondages'],
    ['74.10Z', 'Activités spécialisées de design'],
    ['74.20Z', 'Activités photographiques'],
    ['74.30Z', 'Traduction et interprétation'],
    ['74.90A', 'Activité des économistes de la construction'],
    ['74.90B', 'Activités spécialisées, scientifiques et techniques diverses'],
    ['75.00Z', 'Activités vétérinaires'],
    ['77.11A', 'Location de courte durée de voitures et de véhicules automobiles légers'],
    ['77.11B', 'Location de longue durée de voitures et de véhicules automobiles légers'],
    ['77.12Z', 'Location et location-bail de camions'],
    ['77.21Z', "Location et location-bail d'articles de loisirs et de sport "],
    ['77.22Z', 'Location de vidéocassettes et disques vidéo'],
    ['77.29Z', "Location et location-bail d'autres biens personnels et domestiques"],
    ['77.31Z', 'Location et location-bail de machines et équipements agricoles'],
    ['77.32Z', 'Location et location-bail de machines et équipements pour la construction'],
    ['77.33Z', 'Location et location-bail de machines de bureau et de matériel informatique'],
    ['77.34Z', 'Location et location-bail de matériels de transport par eau'],
    ['77.35Z', 'Location et location-bail de matériels de transport aérien'],
    ['77.39Z', "Location et location-bail d'autres machines, équipements et biens matériels n.c.a. "],
    [
        '77.40Z',
        "Location-bail de propriété intellectuelle et de produits similaires, à l'exception des œuvres soumises à copyright",
    ],
    ['78.10Z', "Activités des agences de placement de main-d'œuvre "],
    ['78.20Z', 'Activités des agences de travail temporaire '],
    ['78.30Z', 'Autre mise à disposition de ressources humaines'],
    ['79.11Z', 'Activités des agences de voyage'],
    ['79.12Z', 'Activités des voyagistes'],
    ['79.90Z', 'Autres services de réservation et activités connexes'],
    ['80.10Z', 'Activités de sécurité privée '],
    ['80.20Z', 'Activités liées aux systèmes de sécurité '],
    ['80.30Z', "Activités d'enquête"],
    ['81.10Z', 'Activités combinées de soutien lié aux bâtiments '],
    ['81.21Z', 'Nettoyage courant des bâtiments'],
    ['81.22Z', 'Autres activités de nettoyage des bâtiments et nettoyage industriel'],
    ['81.29A', 'Désinfection, désinsectisation, dératisation'],
    ['81.29B', 'Autres activités de nettoyage n.c.a.'],
    ['81.30Z', "Services d'aménagement paysager "],
    ['82.11Z', 'Services administratifs combinés de bureau'],
    [
        '82.19Z',
        'Photocopie, préparation de documents et autres activités spécialisées de soutien de bureau',
    ],
    ['82.20Z', "Activités de centres d'appels"],
    ['82.30Z', 'Organisation de foires, salons professionnels et congrès'],
    [
        '82.91Z',
        "Activités des agences de recouvrement de factures et des sociétés d'information financière sur la clientèle",
    ],
    ['82.92Z', 'Activités de conditionnement'],
    ['82.99Z', 'Autres activités de soutien aux entreprises n.c.a.'],
    ['84.11Z', 'Administration publique générale'],
    [
        '84.12Z',
        'Administration publique (tutelle) de la santé, de la formation, de la culture et des services sociaux, autre que sécurité sociale ',
    ],
    ['84.13Z', 'Administration publique (tutelle) des activités économiques'],
    ['84.21Z', 'Affaires étrangères'],
    ['84.22Z', 'Défense'],
    ['84.23Z', 'Justice'],
    ['84.24Z', 'Activités d’ordre public et de sécurité'],
    ['84.25Z', 'Services du feu et de secours'],
    ['84.30A', 'Activités générales de sécurité sociale'],
    ['84.30B', 'Gestion des retraites complémentaires'],
    ['84.30C', 'Distribution sociale de revenus'],
    ['85.10Z', 'Enseignement pré-primaire'],
    ['85.20Z', 'Enseignement primaire'],
    ['85.31Z', 'Enseignement secondaire général'],
    ['85.32Z', 'Enseignement secondaire technique ou professionnel'],
    ['85.41Z', 'Enseignement post-secondaire non supérieur'],
    ['85.42Z', 'Enseignement supérieur'],
    ['85.51Z', "Enseignement de disciplines sportives et d'activités de loisirs"],
    ['85.52Z', 'Enseignement culturel'],
    ['85.53Z', 'Enseignement de la conduite'],
    ['85.59A', "Formation continue d'adultes"],
    ['85.59B', 'Autres enseignements'],
    ['85.60Z', "Activités de soutien à l'enseignement"],
    ['86.10Z', 'Activités hospitalières'],
    ['86.21Z', 'Activité des médecins généralistes'],
    ['86.22A', 'Activités de radiodiagnostic et de radiothérapie'],
    ['86.22B', 'Activités chirurgicales'],
    ['86.22C', 'Autres activités des médecins spécialistes'],
    ['86.23Z', 'Pratique dentaire'],
    ['86.90A', 'Ambulances'],
    ['86.90B', "Laboratoires d'analyses médicales"],
    ['86.90C', "Centres de collecte et banques d'organes"],
    ['86.90D', 'Activités des infirmiers et des sages-femmes'],
    [
        '86.90E',
        'Activités des professionnels de la rééducation, de l’appareillage et des pédicures-podologues',
    ],
    ['86.90F', 'Activités de santé humaine non classées ailleurs'],
    ['87.10A', 'Hébergement médicalisé pour personnes âgées'],
    ['87.10B', 'Hébergement médicalisé pour enfants handicapés '],
    ['87.10C', 'Hébergement médicalisé pour adultes handicapés et autre hébergement médicalisé \n'],
    ['87.20A', 'Hébergement social pour handicapés mentaux et malades mentaux '],
    ['87.20B', 'Hébergement social pour toxicomanes'],
    ['87.30A', 'Hébergement social pour personnes âgées'],
    ['87.30B', 'Hébergement social pour handicapés  physiques'],
    ['87.90A', 'Hébergement social pour enfants en difficultés '],
    [
        '87.90B',
        'Hébergement social pour adultes et familles en difficultés et autre hébergement social ',
    ],
    ['88.10A', 'Aide à domicile  '],
    [
        '88.10B',
        'Accueil ou accompagnement sans hébergement d’adultes handicapés ou de  personnes âgées',
    ],
    ['88.10C', 'Aide par le travail '],
    ['88.91A', 'Accueil de jeunes enfants'],
    ['88.91B', 'Accueil ou accompagnement sans hébergement d’enfants handicapés'],
    ['88.99A', 'Autre accueil ou accompagnement sans hébergement d’enfants\n et d’adolescents\n'],
    ['88.99B', 'Action sociale sans hébergement n.c.a.'],
    ['90.01Z', 'Arts du spectacle vivant'],
    ['90.02Z', 'Activités de soutien au spectacle vivant'],
    ['90.03A', 'Création artistique relevant des arts plastiques'],
    ['90.03B', 'Autre création artistique'],
    ['90.04Z', 'Gestion de salles de spectacles'],
    ['91.01Z', 'Gestion des bibliothèques et des archives'],
    ['91.02Z', 'Gestion des musées'],
    [
        '91.03Z',
        'Gestion des sites et monuments historiques et des attractions touristiques similaires',
    ],
    ['91.04Z', 'Gestion des jardins botaniques et zoologiques et des réserves naturelles'],
    ['92.00Z', "Organisation de jeux de hasard et d'argent"],
    ['93.11Z', "Gestion d'installations sportives"],
    ['93.12Z', 'Activités de clubs de sports'],
    ['93.13Z', 'Activités des centres de culture physique'],
    ['93.19Z', 'Autres activités liées au sport'],
    ['93.21Z', "Activités des parcs d'attractions et parcs à thèmes"],
    ['93.29Z', 'Autres activités récréatives et de loisirs'],
    ['94.11Z', 'Activités des organisations patronales et consulaires'],
    ['94.12Z', 'Activités des organisations professionnelles'],
    ['94.20Z', 'Activités des syndicats de salariés'],
    ['94.91Z', 'Activités des organisations religieuses'],
    ['94.92Z', 'Activités des organisations politiques'],
    ['94.99Z', 'Autres organisations fonctionnant par adhésion volontaire'],
    ['95.11Z', "Réparation d'ordinateurs et d'équipements périphériques"],
    ['95.12Z', "Réparation d'équipements de communication"],
    ['95.21Z', 'Réparation de produits électroniques grand public'],
    ['95.22Z', "Réparation d'appareils électroménagers et d'équipements pour la maison et le jardin"],
    ['95.23Z', "Réparation de chaussures et d'articles en cuir"],
    ['95.24Z', "Réparation de meubles et d'équipements du foyer"],
    ['95.25Z', "Réparation d'articles d'horlogerie et de bijouterie"],
    ['95.29Z', "Réparation d'autres biens personnels et domestiques"],
    ['96.01A', 'Blanchisserie-teinturerie de gros'],
    ['96.01B', 'Blanchisserie-teinturerie de détail'],
    ['96.02A', 'Coiffure'],
    ['96.02B', 'Soins de beauté'],
    ['96.03Z', 'Services funéraires'],
    ['96.04Z', 'Entretien corporel'],
    ['96.09Z', 'Autres services personnels n.c.a.'],
    ['97.00Z', "Activités des ménages en tant qu'employeurs de personnel domestique"],
    [
        '98.10Z',
        'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
    ],
    [
        '98.20Z',
        'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
    ],
    ['99.00Z', 'Activités des organisations et organismes extraterritoriaux'],
];
//# sourceMappingURL=industry-codes.js.map